

// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { useLoader } from "../../../../context/LoaderProvider.jsx";
// import {
//     getAllCampaignsAPI,
//     getAllScreensAPI,
//     updateCampaignApprovalAPI,
//     deleteCampaignAPI,
//     getCampaignByIdAPI,
//     createCampaignAPI,
// } from "../../../../Component/Servicefile/campaignService";
// const FoodSuperadminCampaign = () => {
//     const [campaigns, setCampaigns] = useState([]);
//     const [formData, setFormData] = useState({
//         campaignName: "",
//         description: "",
//         interests: ["JOBS"],
//         goal: "BRANDING",
//         medium: "APP",
//         status: "ACTIVE",
//         startDate: "",
//         subGoal: "",
//         endDate: "",
//         city: "",
//         radiusKm: 100,
//         centerLatitude: 17.3850,
//         centerLongitude: 78.4867,
//         deepLink: "",
//         appType: "FOOD_AND_BEVERAGES",
//         mediaType: "IMAGE",
//         addDisplayPosition: "ADD_SCREEN",
//         customerId: "ADM161220251",
//         paymentStatus: "PENDING",
//         loops: 7,
//         period: "PER_DAY",
//         targetAudience: ["Users"], // ✅ ADD THIS
//         targeting: {
//             interests: ["JOBS"],
//             city: "",
//             centerLatitude: 17.3850,
//             centerLongitude: 78.4867,
//             radiusKm: 100,
//             targetAudience: ["Users"],
//         }
//     });
//     const [showAddModal, setShowAddModal] = useState(false);
//     const [showEditModal, setShowEditModal] = useState(false);
//     const [showViewModal, setShowViewModal] = useState(false);
//     const [selectedCampaign, setSelectedCampaign] = useState(null);
//     const [viewCampaign, setViewCampaign] = useState(null);
//     const [creativeFile, setCreativeFile] = useState(null);
//     const { showLoader, hideLoader } = useLoader();
//     const [loading, setLoading] = useState(true);
//     const [locationLoaded, setLocationLoaded] = useState(false);
//     const isMobile = window.innerWidth <= 768;

//     // Digital-specific states
//     const [screenIds, setScreenIds] = useState([]);
//     const [screens, setScreens] = useState([]);
//     const [loadingScreens, setLoadingScreens] = useState(false);
//     const [creativeResolution, setCreativeResolution] = useState(null);
//     const [creativeDuration, setCreativeDuration] = useState(null);
//     const [creativeValidationMessages, setCreativeValidationMessages] = useState([]);

//     // New state for rejection input inside view modal
//     const [showRejectionInput, setShowRejectionInput] = useState(false);
//     const [rejectionReason, setRejectionReason] = useState('');

//     // New state for approval modal
//     const [showApprovalModal, setShowApprovalModal] = useState(false);
//     const [selectedCampaignForApproval, setSelectedCampaignForApproval] = useState(null);
//     const [approvalData, setApprovalData] = useState({
//         campaignId: null,
//         approvalStatus: "PENDING",
//         rejectionReason: ""
//     });

//     // New state for media preview outside popup
//     const [showMediaPreview, setShowMediaPreview] = useState(false);
//     const [previewMediaUrl, setPreviewMediaUrl] = useState('');
//     const [previewMediaType, setPreviewMediaType] = useState('');

//     // Refs
//     const mapRef = useRef(null);
//     const mapInstanceRef = useRef(null);
//     const markerRef = useRef(null);
//     const circleRef = useRef(null);
//     const searchInputRef = useRef(null);

//     // Interest options (matches enum)
//     const interestOptions = [
//         "JOBS",
//         "FOOD",
//         "EDUCATION",
//         "OFFERS",
//         "REAL_ESTATE",
//         "ONLINE_COURSES",
//         "BAKERY",
//         "HEALTH",
//         "TRAVEL",
//         "ENTERTAINMENT"
//     ];

//     // Goal options
//     const goalOptions = [
//         "BRANDING",
//         "DISCOUNT",
//         "LEADS",
//         "EVENTS",
//         "SPONSORSHIP"
//     ];
//     const subGoalOptionsMap = {
//         BRANDING: [
//             "BRAND_AWARENESS",
//             "BRAND_RECALL",
//             "PREMIUM_POSTING"
//         ],
//         LEADS: [
//             "GET_MORE_MESSAGES",
//             "GET_MORE_CALLS",
//             "GET_MORE_WHATSAPP_MESSAGE",
//             "GET_MORE_PAGE_LIKES",
//             "GET_MORE_LEADS",
//             "GET_MORE_WEBSITE_VISITORS"
//         ]
//     };
//     const subGoalOptions = subGoalOptionsMap[formData.goal] || [];
//     // Medium options
//     const mediumOptions = [
//         "APP",
//         "DIGITAL",
//         "PHYSICAL"
//     ];

//     // Status options
//     const statusOptions = [
//         "DRAFT",
//         "SCHEDULED",
//         "ACTIVE",
//         "PAUSED",
//         "COMPLETED",
//         "CANCELLED"
//     ];

//     // Approval Status options
//     const approvalStatusOptions = [
//         "PENDING",
//         "APPROVED",
//         "REJECTED"
//     ];

//     // Payment Status options
//     const paymentStatusOptions = [
//         "PENDING",
//         "PAID",
//         "FAILED",
//         "REFUNDED",
//         "CANCELLED"
//     ];

//     // App Type options
//     const appTypeOptions = [
//         "FOOD_AND_BEVERAGES",
//         "RETAIL",
//         "SERVICES",
//         "ENTERTAINMENT",
//         "EDUCATION",
//         "HEALTHCARE"
//     ];

//     // Add Display Position options
//     const displayPositionOptions = [
//         "ADD_SCREEN",
//         "HOMEPAGE_BANNER",
//         "PRODUCT_PAGE",
//         "CHECKOUT_PAGE",
//         "IN_APP_POPUP"
//     ];

//     // Media type options
//     const mediaTypeOptions = [
//         "IMAGE",
//         "VIDEO"
//     ];

//     // Display Position Best Ratio mapping
//     const displayPositionRatios = {
//         "ADD_SCREEN": { ratio: "9:16", resolution: "R_720P", description: "Full-screen vertical ad" },
//         "HOMEPAGE_BANNER": { ratio: "16:9", resolution: "R_4K", description: "Wide banner style" },
//         "PRODUCT_PAGE": { ratio: "4:5", resolution: "R_1080P", description: "Product-focused layout" },
//         "CHECKOUT_PAGE": { ratio: "4:5", resolution: "R_1080P", description: "Compact promotional block" },
//         "IN_APP_POPUP": { ratio: "9:16", resolution: "R_720P", description: "Overlay popup style" }
//     };

//     // Creative requirements based on display position
//     const getCreativeRequirements = (position) => {
//         const requirements = {
//             "ADD_SCREEN": {
//                 formats: ["JPG", "PNG", "MP4"],
//                 dimensions: "1920x1080 pixels",
//                 maxSize: "6 MB for images, 10 MB for videos",
//                 aspectRatio: "16:9",
//                 duration: "15-30 seconds for videos",
//                 bestRatio: "9:16 (R_720P)"
//             },
//             "HOMEPAGE_BANNER": {
//                 formats: ["JPG", "PNG", "GIF"],
//                 dimensions: "1200x400 pixels",
//                 maxSize: "2 MB for images, 5 MB for GIFs",
//                 aspectRatio: "3:1",
//                 duration: "N/A",
//                 bestRatio: "16:9 (R_4K)"
//             },
//             "PRODUCT_PAGE": {
//                 formats: ["JPG", "PNG"],
//                 dimensions: "800x800 pixels",
//                 maxSize: "1 MB",
//                 aspectRatio: "1:1",
//                 duration: "N/A",
//                 bestRatio: "4:5 (R_1080P)"
//             },
//             "CHECKOUT_PAGE": {
//                 formats: ["JPG", "PNG"],
//                 dimensions: "600x200 pixels",
//                 maxSize: "500 KB",
//                 aspectRatio: "3:1",
//                 duration: "N/A",
//                 bestRatio: "4:5 (R_1080P)"
//             },
//             "IN_APP_POPUP": {
//                 formats: ["JPG", "PNG", "MP4"],
//                 dimensions: "800x600 pixels",
//                 maxSize: "2 MB for images, 8 MB for videos",
//                 aspectRatio: "4:3",
//                 duration: "10-15 seconds for videos",
//                 bestRatio: "9:16 (R_720P)"
//             }
//         };
//         return requirements[position] || requirements["ADD_SCREEN"];
//     };

//     // Function to compress image
//     const compressImage = (file) => {
//         return new Promise((resolve, reject) => {
//             const reader = new FileReader();
//             reader.readAsDataURL(file);
//             reader.onload = (event) => {
//                 const img = new Image();
//                 img.src = event.target.result;
//                 img.onload = () => {
//                     const canvas = document.createElement('canvas');
//                     const ctx = canvas.getContext('2d');

//                     // Calculate new dimensions (maintain aspect ratio)
//                     let width = img.width;
//                     let height = img.height;

//                     // Reduce quality by 30%
//                     const quality = 0.7;

//                     canvas.width = width;
//                     canvas.height = height;

//                     ctx.drawImage(img, 0, 0, width, height);

//                     canvas.toBlob((blob) => {
//                         const compressedFile = new File([blob], file.name, {
//                             type: file.type,
//                             lastModified: Date.now()
//                         });
//                         resolve(compressedFile);
//                     }, file.type, quality);
//                 };
//                 img.onerror = (error) => reject(error);
//             };
//             reader.onerror = (error) => reject(error);
//         });
//     };

//     // Function to compress video
//     const compressVideo = (file) => {
//         return new Promise((resolve, reject) => {
//             console.log("Video compression would happen here - returning original for now");
//             resolve(file);
//         });
//     };

//     // Load Google Maps script once
//     useEffect(() => {
//         if (!document.querySelector('script[src*="maps.googleapis.com"]')) {
//             const script = document.createElement('script');
//             script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyD_peZch6hJtq-3wEE4-4z3r68o7Y7nw3c&libraries=places`;
//             script.async = true;
//             script.defer = true;
//             script.onload = () => {
//                 console.log("Google Maps loaded successfully");
//             };
//             document.head.appendChild(script);
//         }
//     }, []);

//     // Fetch all campaigns
//     useEffect(() => {
//         const fetchCampaigns = async () => {
//             try {
//                 showLoader();
//                 setLoading(true);

//                 const result =
//                     await getAllCampaignsAPI();

//                 const campaignsArray =
//                     Array.isArray(result)
//                         ? result
//                         : [result];

//                 setCampaigns(campaignsArray);

//             } catch (error) {
//                 console.error(
//                     "❌ Error fetching campaigns:",
//                     error
//                 );

//                 alert("Failed to fetch campaigns");

//             } finally {
//                 setLoading(false);
//                 hideLoader();
//             }
//         };

//         fetchCampaigns();
//     }, []);

//     // Fetch screens when modal opens for DIGITAL medium
//     useEffect(() => {
//         if ((showAddModal || showEditModal) && formData.medium === "DIGITAL") {
//             fetchScreens();
//         }
//     }, [showAddModal, showEditModal, formData.medium]);

//     // Fetch screens from API
//     const fetchScreens = async () => {
//         try {
//             setLoadingScreens(true);

//             const screensData =
//                 await getAllScreensAPI();

//             console.log(
//                 "Screens response:",
//                 screensData
//             );

//             setScreens(screensData);

//             if (screensData.length === 0) {
//                 console.warn(
//                     "No screens found in response"
//                 );
//             }

//         } catch (error) {
//             console.error(
//                 "❌ Error fetching screens:",
//                 error
//             );

//             alert(
//                 "Failed to fetch screens. Please try again."
//             );

//             setScreens([]);

//         } finally {
//             setLoadingScreens(false);
//         }
//     };

//     // Initialize map when modal opens
//     useEffect(() => {
//         if ((showAddModal || showEditModal) && window.google) {
//             setTimeout(() => {
//                 initMap();
//             }, 300);
//         } else {
//             if (mapInstanceRef.current) {
//                 mapInstanceRef.current = null;
//                 markerRef.current = null;
//                 circleRef.current = null;
//             }
//         }
//     }, [showAddModal, showEditModal]);

//     // Get current location
//     const getCurrentLocation = () => {
//         if (navigator.geolocation) {
//             setLocationLoaded(false);
//             navigator.geolocation.getCurrentPosition(
//                 (position) => {
//                     const { latitude, longitude } = position.coords;
//                     setFormData(prev => ({
//                         ...prev,
//                         centerLatitude: latitude,
//                         centerLongitude: longitude,
//                         targeting: {
//                             ...prev.targeting,
//                             centerLatitude: latitude,
//                             centerLongitude: longitude
//                         }
//                     }));

//                     if (mapInstanceRef.current) {
//                         const newPosition = { lat: latitude, lng: longitude };
//                         mapInstanceRef.current.setCenter(newPosition);
//                         mapInstanceRef.current.setZoom(13);
//                         if (markerRef.current) {
//                             markerRef.current.setPosition(newPosition);
//                         }
//                         updateCircle();
//                     }
//                     setLocationLoaded(true);
//                 },
//                 (error) => {
//                     console.error("Error getting location:", error);
//                     alert("Please enable location services");
//                     setLocationLoaded(true);
//                 }
//             );
//         } else {
//             alert("Geolocation is not supported by this browser");
//             setLocationLoaded(true);
//         }
//     };

//     // Go to city
//     const goToCity = (cityName) => {
//         if (!cityName || !window.google) {
//             alert("Please enter a city name");
//             return;
//         }

//         setLocationLoaded(false);

//         const geocoder = new window.google.maps.Geocoder();
//         geocoder.geocode({ address: cityName }, (results, status) => {
//             if (status === 'OK' && results[0]) {
//                 const location = results[0].geometry.location;
//                 const lat = location.lat();
//                 const lng = location.lng();

//                 let cityNameFromResult = cityName;
//                 for (const component of results[0].address_components) {
//                     if (component.types.includes('locality') ||
//                         component.types.includes('administrative_area_level_2') ||
//                         component.types.includes('administrative_area_level_1')) {
//                         cityNameFromResult = component.long_name;
//                         break;
//                     }
//                 }

//                 setFormData(prev => ({
//                     ...prev,
//                     centerLatitude: lat,
//                     centerLongitude: lng,
//                     city: cityNameFromResult,
//                     targeting: {
//                         ...prev.targeting,
//                         centerLatitude: lat,
//                         centerLongitude: lng,
//                         city: cityNameFromResult
//                     }
//                 }));

//                 if (mapInstanceRef.current) {
//                     const newPosition = { lat, lng };
//                     mapInstanceRef.current.setCenter(newPosition);
//                     mapInstanceRef.current.setZoom(13);
//                     if (markerRef.current) {
//                         markerRef.current.setPosition(newPosition);
//                     }
//                     updateCircle();
//                 }
//                 setLocationLoaded(true);
//             } else {
//                 alert(`City "${cityName}" not found`);
//                 setLocationLoaded(true);
//             }
//         });
//     };

//     // Update circle based on radius
//     const updateCircle = () => {
//         if (!mapInstanceRef.current || !formData.centerLatitude || !formData.centerLongitude) return;

//         if (circleRef.current) {
//             circleRef.current.setMap(null);
//             circleRef.current = null;
//         }

//         if (formData.radiusKm > 0) {
//             const circle = new window.google.maps.Circle({
//                 strokeColor: '#FF5722',
//                 strokeOpacity: 0.8,
//                 strokeWeight: 2,
//                 fillColor: '#FF5722',
//                 fillOpacity: 0.2,
//                 map: mapInstanceRef.current,
//                 center: { lat: formData.centerLatitude, lng: formData.centerLongitude },
//                 radius: formData.radiusKm * 1000
//             });
//             circleRef.current = circle;
//         }
//     };

//     // Initialize map
//     const initMap = () => {
//         const mapId = showAddModal ? 'add-map' : 'edit-map';
//         const mapElement = document.getElementById(mapId);

//         if (!mapElement || !window.google) {
//             console.log("Map element or Google not ready");
//             return;
//         }

//         console.log("Initializing map for", mapId);

//         const defaultLocation = {
//             lat: formData.centerLatitude || 17.3850,
//             lng: formData.centerLongitude || 78.4867
//         };

//         const map = new window.google.maps.Map(mapElement, {
//             center: defaultLocation,
//             zoom: 13,
//             mapTypeControl: false,
//             streetViewControl: false,
//             fullscreenControl: true,
//             zoomControl: true
//         });

//         const marker = new window.google.maps.Marker({
//             position: defaultLocation,
//             map: map,
//             draggable: true,
//             animation: window.google.maps.Animation.DROP,
//             title: "Drag to set location"
//         });

//         marker.addListener('dragend', () => {
//             const position = marker.getPosition();
//             setFormData(prev => ({
//                 ...prev,
//                 centerLatitude: position.lat(),
//                 centerLongitude: position.lng(),
//                 targeting: {
//                     ...prev.targeting,
//                     centerLatitude: position.lat(),
//                     centerLongitude: position.lng()
//                 }
//             }));
//             updateCircle();
//         });

//         map.addListener('click', (e) => {
//             marker.setPosition(e.latLng);
//             setFormData(prev => ({
//                 ...prev,
//                 centerLatitude: e.latLng.lat(),
//                 centerLongitude: e.latLng.lng(),
//                 targeting: {
//                     ...prev.targeting,
//                     centerLatitude: e.latLng.lat(),
//                     centerLongitude: e.latLng.lng()
//                 }
//             }));
//             updateCircle();
//         });

//         if (searchInputRef.current) {
//             const searchBox = new window.google.maps.places.SearchBox(searchInputRef.current);

//             map.addListener('bounds_changed', () => {
//                 searchBox.setBounds(map.getBounds());
//             });

//             searchBox.addListener('places_changed', () => {
//                 const places = searchBox.getPlaces();
//                 if (places.length === 0) return;

//                 const place = places[0];
//                 if (!place.geometry) return;

//                 if (place.geometry.viewport) {
//                     map.fitBounds(place.geometry.viewport);
//                 } else {
//                     map.setCenter(place.geometry.location);
//                     map.setZoom(15);
//                 }

//                 marker.setPosition(place.geometry.location);

//                 let cityName = formData.city;
//                 if (place.address_components) {
//                     for (const component of place.address_components) {
//                         if (component.types.includes('locality') ||
//                             component.types.includes('administrative_area_level_2')) {
//                             cityName = component.long_name;
//                             break;
//                         }
//                     }
//                 }

//                 setFormData(prev => ({
//                     ...prev,
//                     centerLatitude: place.geometry.location.lat(),
//                     centerLongitude: place.geometry.location.lng(),
//                     city: cityName,
//                     targeting: {
//                         ...prev.targeting,
//                         centerLatitude: place.geometry.location.lat(),
//                         centerLongitude: place.geometry.location.lng(),
//                         city: cityName
//                     }
//                 }));
//                 updateCircle();
//             });
//         }

//         mapInstanceRef.current = map;
//         markerRef.current = marker;
//         setLocationLoaded(true);

//         setTimeout(() => updateCircle(), 500);
//     };

//     // Handle form input changes
//     const handleChange = (e) => {
//         const { name, value } = e.target;

//         if (name === "centerLatitude" || name === "centerLongitude") {
//             const numValue = parseFloat(value) || 0;
//             setFormData(prev => ({
//                 ...prev,
//                 [name]: numValue,
//                 targeting: {
//                     ...prev.targeting,
//                     [name]: numValue
//                 }
//             }));
//         } else {
//             setFormData(prev => ({
//                 ...prev,
//                 [name]: value,
//                 targeting: {
//                     ...prev.targeting,
//                     [name]: value
//                 }
//             }));
//         }

//         if (name === 'radiusKm' && mapInstanceRef.current) {
//             setTimeout(() => updateCircle(), 100);
//         }
//     };

//     // Handle screen selection with checkboxes
//     const handleScreenSelection = (screenId) => {
//         setScreenIds(prev => {
//             if (prev.includes(screenId)) {
//                 return prev.filter(id => id !== screenId);
//             } else {
//                 return [...prev, screenId];
//             }
//         });
//     };

//     // Check if creative is valid for screens
//     const isCreativeValidForScreens = () => {
//         if (!creativeFile) return false;

//         const fileExt = creativeFile.name.split('.').pop().toUpperCase();
//         const videoExtensions = ['MP4', 'MOV', 'AVI', 'MKV', 'WEBM', 'OGG'];
//         const isVideo = videoExtensions.includes(fileExt);

//         // For videos, check duration (max 20 seconds)
//         if (isVideo && creativeDuration && creativeDuration > 20) {
//             return false;
//         }

//         return true;
//     };

//     // Get creative resolution string
//     const getCreativeResolution = () => {
//         return "16:9 (1920x1080)";
//     };

//     // Check if a screen is compatible with the uploaded creative
//     const isScreenCompatible = (screen) => {
//         if (!creativeFile) return false;

//         const fileExt = creativeFile.name.split('.').pop().toUpperCase();
//         const videoExtensions = ['MP4', 'MOV', 'AVI', 'MKV', 'WEBM', 'OGG'];
//         const isVideo = videoExtensions.includes(fileExt);

//         // Check video duration
//         if (isVideo && creativeDuration && creativeDuration > 20) {
//             return false;
//         }

//         // Digital screens typically require 16:9 aspect ratio
//         const screenResolution = screen.resolution || screen.aspectRatio || '';
//         const screenRatio = screenResolution.toLowerCase();

//         // Accept screens with 16:9 resolution or standard digital display resolutions
//         const compatibleResolutions = ['16:9', '1920x1080', '1280x720', '3840x2160'];
//         const isCompatible = compatibleResolutions.some(res => screenRatio.includes(res.toLowerCase()));

//         return isCompatible;
//     };

//     // Get compatible screens
//     const getCompatibleScreens = () => {
//         if (!creativeFile) return [];
//         return screens.filter(screen => isScreenCompatible(screen));
//     };

//     // Handle select all compatible screens
//     const handleSelectAllCompatibleScreens = () => {
//         const compatibleScreens = getCompatibleScreens().map(screen => screen.id || screen.screenId);

//         if (screenIds.length === compatibleScreens.length) {
//             setScreenIds([]);
//         } else {
//             setScreenIds(compatibleScreens);
//         }
//     };

//     // Handle creative file selection with compression and validation
//     const handleCreativeChange = async (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         try {
//             showLoader();

//             const requirements = getCreativeRequirements(formData.addDisplayPosition);
//             const fileExt = file.name.split('.').pop().toUpperCase();
//             const fileSizeInMB = file.size / (1024 * 1024);
//             const videoExtensions = ['MP4', 'MOV', 'AVI', 'MKV', 'WEBM', 'OGG'];
//             const isVideo = videoExtensions.includes(fileExt);

//             if (!requirements.formats.includes(fileExt)) {
//                 alert(`Invalid file format. Please upload: ${requirements.formats.join(', ')}`);
//                 e.target.value = '';
//                 hideLoader();
//                 return;
//             }

//             const detectedMediaType = isVideo ? 'VIDEO' : 'IMAGE';

//             if (detectedMediaType !== formData.mediaType) {
//                 alert(`File type mismatch. You selected ${formData.mediaType} but uploaded a ${detectedMediaType} file.`);
//                 e.target.value = '';
//                 hideLoader();
//                 return;
//             }

//             const maxSize = isVideo ?
//                 parseFloat(requirements.maxSize.split(',')[1]?.split('MB')[0] || '10') :
//                 parseFloat(requirements.maxSize.split('MB')[0]);

//             if (fileSizeInMB > maxSize) {
//                 alert(`File size too large. Maximum size: ${requirements.maxSize}`);
//                 e.target.value = '';
//                 hideLoader();
//                 return;
//             }

//             // For videos, check duration
//             if (isVideo) {
//                 const video = document.createElement('video');
//                 video.preload = 'metadata';

//                 const duration = await new Promise((resolve) => {
//                     video.onloadedmetadata = () => {
//                         resolve(video.duration);
//                     };
//                     video.src = URL.createObjectURL(file);
//                 });

//                 setCreativeDuration(duration);

//                 if (duration > 20) {
//                     alert(`Video duration too long. Maximum duration is 20 seconds. Your video is ${Math.round(duration)} seconds.`);
//                     e.target.value = '';
//                     URL.revokeObjectURL(video.src);
//                     hideLoader();
//                     return;
//                 }

//                 URL.revokeObjectURL(video.src);
//             } else {
//                 setCreativeDuration(null);
//             }

//             // Set creative resolution info
//             setCreativeResolution("16:9 (1920x1080)");

//             // Build validation messages
//             const messages = [];
//             messages.push({
//                 message: `Format: ${fileExt}`,
//                 valid: true
//             });
//             messages.push({
//                 message: `Size: ${fileSizeInMB.toFixed(2)}MB / ${maxSize}MB`,
//                 valid: fileSizeInMB <= maxSize
//             });
//             if (isVideo) {
//                 messages.push({
//                     message: `Duration: ${creativeDuration?.toFixed(1) || '?'}s / 20s`,
//                     valid: creativeDuration <= 20
//                 });
//             }
//             setCreativeValidationMessages(messages);

//             let compressedFile = file;
//             if (isVideo) {
//                 compressedFile = await compressVideo(file);
//                 console.log(`Video compressed by 30%: ${(file.size / (1024 * 1024)).toFixed(2)}MB → ${(compressedFile.size / (1024 * 1024)).toFixed(2)}MB`);
//             } else {
//                 compressedFile = await compressImage(file);
//                 console.log(`Image compressed by 30%: ${(file.size / (1024 * 1024)).toFixed(2)}MB → ${(compressedFile.size / (1024 * 1024)).toFixed(2)}MB`);
//             }

//             setCreativeFile(compressedFile);

//             // Reset screen selection when new creative is uploaded
//             setScreenIds([]);

//             alert(`File processed successfully! Original: ${fileSizeInMB.toFixed(2)}MB, Compressed: ${(compressedFile.size / (1024 * 1024)).toFixed(2)}MB`);

//         } catch (error) {
//             console.error("Error processing file:", error);
//             alert("Error processing file. Please try again.");
//         } finally {
//             hideLoader();
//         }
//     };

//     // Handle approval input changes
//     const handleApprovalChange = (e) => {
//         const { name, value } = e.target;
//         setApprovalData(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     // Fetch campaign by ID
//     const fetchCampaignById = async (
//         campaignId
//     ) => {
//         try {
//             showLoader();

//             const data =
//                 await getCampaignByIdAPI(
//                     campaignId
//                 );

//             console.log(
//                 "Campaign details:",
//                 data
//             );

//             return data;

//         } catch (error) {
//             console.error(
//                 "❌ Error fetching campaign:",
//                 error
//             );

//             alert(
//                 "Failed to fetch campaign details"
//             );

//             return null;

//         } finally {
//             hideLoader();
//         }
//     };

//     // Update campaign approval status
//     const handleApprovalUpdate = async (
//         e
//     ) => {
//         e.preventDefault();

//         if (!selectedCampaignForApproval) {
//             alert(
//                 "No campaign selected for approval"
//             );

//             return;
//         }

//         try {
//             showLoader();

//             const campaignId =
//                 selectedCampaignForApproval.id ||
//                 selectedCampaignForApproval.campaignId;

//             const response =
//                 await updateCampaignApprovalAPI({
//                     campaignId,
//                     approvalStatus:
//                         approvalData.approvalStatus,
//                     rejectionReason:
//                         approvalData.rejectionReason ||
//                         "",
//                 });

//             console.log(
//                 "Approval response:",
//                 response
//             );

//             const updatedCampaignId =
//                 response.campaignId ||
//                 campaignId;

//             setCampaigns((prev) =>
//                 prev.map((campaign) => {
//                     if (
//                         campaign.id ===
//                         updatedCampaignId ||
//                         campaign.campaignId ===
//                         updatedCampaignId ||
//                         campaign.id ===
//                         campaignId
//                     ) {
//                         return {
//                             ...campaign,
//                             approvalStatus:
//                                 approvalData.approvalStatus,
//                         };
//                     }

//                     return campaign;
//                 })
//             );

//             if (
//                 viewCampaign &&
//                 (viewCampaign.id ===
//                     updatedCampaignId ||
//                     viewCampaign.id ===
//                     campaignId)
//             ) {
//                 setViewCampaign((prev) => ({
//                     ...prev,
//                     approvalStatus:
//                         approvalData.approvalStatus,
//                 }));
//             }

//             alert(
//                 `Campaign ${approvalData.approvalStatus.toLowerCase()} successfully!`
//             );

//             setShowApprovalModal(false);

//             setSelectedCampaignForApproval(
//                 null
//             );

//             setApprovalData({
//                 campaignId: null,
//                 approvalStatus: "PENDING",
//                 rejectionReason: "",
//             });

//         } catch (error) {
//             console.error(
//                 "❌ Error updating campaign approval:",
//                 error.response?.data ||
//                 error.message
//             );

//             alert(
//                 `Failed to update campaign approval: ${error.response?.data
//                     ?.message ||
//                 error.message
//                 }`
//             );

//         } finally {
//             hideLoader();
//         }
//     };

//     // Direct Approve function (from view modal)
//     const handleDirectApprove = async (
//         campaign
//     ) => {
//         if (
//             !window.confirm(
//                 `Are you sure you want to approve campaign "${campaign.campaignName}"?`
//             )
//         ) {
//             return;
//         }

//         try {
//             showLoader();

//             const campaignId =
//                 campaign.id ||
//                 campaign.campaignId;

//             if (!campaignId) {
//                 throw new Error(
//                     "Campaign ID not found"
//                 );
//             }

//             const response =
//                 await updateCampaignApprovalAPI({
//                     campaignId,
//                     approvalStatus:
//                         "APPROVED",
//                     rejectionReason: "",
//                 });

//             console.log(
//                 "Approval response:",
//                 response
//             );

//             setCampaigns((prev) =>
//                 prev.map((c) => {
//                     if (
//                         c.id === campaignId ||
//                         c.campaignId ===
//                         campaignId
//                     ) {
//                         return {
//                             ...c,
//                             approvalStatus:
//                                 "APPROVED",
//                         };
//                     }

//                     return c;
//                 })
//             );

//             if (
//                 viewCampaign &&
//                 (viewCampaign.id ===
//                     campaignId ||
//                     viewCampaign.campaignId ===
//                     campaignId)
//             ) {
//                 setViewCampaign((prev) => ({
//                     ...prev,
//                     approvalStatus:
//                         "APPROVED",
//                 }));
//             }

//             alert(
//                 "Campaign approved successfully!"
//             );

//         } catch (error) {
//             console.error(
//                 "❌ Error approving campaign:",
//                 error
//             );

//             alert(
//                 `Failed to approve campaign: ${error.response?.data
//                     ?.message ||
//                 error.message
//                 }`
//             );

//         } finally {
//             hideLoader();
//         }
//     };

//     // Direct Reject function
//     const handleDirectReject = async (
//         campaign
//     ) => {
//         try {
//             showLoader();

//             const campaignId =
//                 campaign.id ||
//                 campaign.campaignId;

//             if (!campaignId) {
//                 throw new Error(
//                     "Campaign ID not found"
//                 );
//             }

//             const response =
//                 await updateCampaignApprovalAPI({
//                     campaignId,
//                     approvalStatus:
//                         "REJECTED",
//                     rejectionReason:
//                         rejectionReason.trim(),
//                 });

//             console.log(
//                 "Rejection response:",
//                 response
//             );

//             setCampaigns((prev) =>
//                 prev.map((c) => {
//                     if (
//                         c.id === campaignId ||
//                         c.campaignId ===
//                         campaignId
//                     ) {
//                         return {
//                             ...c,
//                             approvalStatus:
//                                 "REJECTED",
//                         };
//                     }

//                     return c;
//                 })
//             );

//             if (
//                 viewCampaign &&
//                 (viewCampaign.id ===
//                     campaignId ||
//                     viewCampaign.campaignId ===
//                     campaignId)
//             ) {
//                 setViewCampaign((prev) => ({
//                     ...prev,
//                     approvalStatus:
//                         "REJECTED",
//                 }));
//             }

//             alert(
//                 "Campaign rejected successfully!"
//             );

//             setShowRejectionInput(false);
//             setRejectionReason("");

//         } catch (error) {
//             console.error(
//                 "❌ Error rejecting campaign:",
//                 error
//             );

//             alert(
//                 `Failed to reject campaign: ${error.response?.data
//                     ?.message ||
//                 error.message
//                 }`
//             );

//         } finally {
//             hideLoader();
//         }
//     };

//     // Refresh campaigns list
//     const refreshCampaigns = async () => {
//         try {
//             const result =
//                 await getAllCampaignsAPI();

//             const campaignsArray =
//                 Array.isArray(result)
//                     ? result
//                     : [result];

//             setCampaigns(campaignsArray);

//             if (viewCampaign) {
//                 const updatedCampaign =
//                     campaignsArray.find(
//                         (c) =>
//                             c.id ===
//                             viewCampaign.id ||
//                             c.campaignId ===
//                             viewCampaign.id
//                     );

//                 if (updatedCampaign) {
//                     setViewCampaign(
//                         updatedCampaign
//                     );
//                 }
//             }

//         } catch (error) {
//             console.error(
//                 "Error refreshing campaigns:",
//                 error
//             );
//         }
//     };

//     // Delete campaign with admin API
//     const handleDelete = async (
//         campaignId
//     ) => {
//         if (
//             !window.confirm(
//                 "Are you sure you want to delete this campaign?"
//             )
//         ) {
//             return;
//         }

//         try {
//             showLoader();

//             await deleteCampaignAPI(
//                 campaignId
//             );

//             setCampaigns((prev) =>
//                 prev.filter(
//                     (campaign) =>
//                         campaign.id !==
//                         campaignId &&
//                         campaign.campaignId !==
//                         campaignId
//                 )
//             );

//             if (
//                 viewCampaign &&
//                 (viewCampaign.id ===
//                     campaignId ||
//                     viewCampaign.campaignId ===
//                     campaignId)
//             ) {
//                 setShowViewModal(false);
//                 setViewCampaign(null);
//             }

//             alert(
//                 "Campaign deleted successfully!"
//             );

//         } catch (error) {
//             console.error(
//                 "❌ Error deleting campaign:",
//                 error.response?.data ||
//                 error.message
//             );

//             alert(
//                 `Failed to delete campaign: ${error.response?.data
//                     ?.message ||
//                 error.message
//                 }`
//             );

//         } finally {
//             hideLoader();
//         }
//     };

//     const handleViewCampaign = async (campaign) => {
//         const campaignId = campaign.id || campaign.campaignId;
//         const fullCampaignDetails = await fetchCampaignById(campaignId);

//         if (fullCampaignDetails) {
//             setViewCampaign(fullCampaignDetails);
//         } else {
//             setViewCampaign(campaign);
//         }
//         setShowRejectionInput(false);
//         setRejectionReason('');
//         setShowViewModal(true);
//     };

//     const handleEditDirect = async (campaign) => {
//         const campaignId = campaign.id || campaign.campaignId;
//         const fullCampaignDetails = await fetchCampaignById(campaignId);

//         if (fullCampaignDetails) {
//             setSelectedCampaign(fullCampaignDetails);
//             setFormData({
//                 campaignName: fullCampaignDetails.campaignName || "",
//                 description: fullCampaignDetails.description || "",
//                 interests: fullCampaignDetails.interests || fullCampaignDetails.targeting?.interests || ["JOBS"],
//                 goal: fullCampaignDetails.goal || "BRANDING",
//                 medium: fullCampaignDetails.medium || "APP",
//                 status: fullCampaignDetails.status || "ACTIVE",
//                 startDate: fullCampaignDetails.startDate ? fullCampaignDetails.startDate.split('T')[0] : "",
//                 endDate: fullCampaignDetails.endDate ? fullCampaignDetails.endDate.split('T')[0] : "",
//                 city: fullCampaignDetails.city || fullCampaignDetails.targeting?.city || "",
//                 radiusKm: fullCampaignDetails.radiusKm || fullCampaignDetails.targeting?.radiusKm || 100,
//                 centerLatitude: fullCampaignDetails.centerLatitude || fullCampaignDetails.targeting?.centerLatitude || 17.3850,
//                 centerLongitude: fullCampaignDetails.centerLongitude || fullCampaignDetails.targeting?.centerLongitude || 78.4867,
//                 deepLink: fullCampaignDetails.deepLink || "",
//                 appType: fullCampaignDetails.appType || "FOOD_AND_BEVERAGES",
//                 mediaType: fullCampaignDetails.mediaType || "IMAGE",
//                 addDisplayPosition: fullCampaignDetails.addDisplayPosition || "ADD_SCREEN",
//                 customerId: fullCampaignDetails.customerId || "ADM161220251",
//                 paymentStatus: fullCampaignDetails.paymentStatus || "PENDING",
//                 loops: fullCampaignDetails.screenRequest?.loops || 7,
//                 period: "PER_DAY",
//                 targeting: {
//                     interests: fullCampaignDetails.targeting?.interests || fullCampaignDetails.interests || ["JOBS"],
//                     city: fullCampaignDetails.targeting?.city || fullCampaignDetails.city || "",
//                     centerLatitude: fullCampaignDetails.targeting?.centerLatitude || fullCampaignDetails.centerLatitude || 17.3850,
//                     centerLongitude: fullCampaignDetails.targeting?.centerLongitude || fullCampaignDetails.centerLongitude || 78.4867,
//                     radiusKm: fullCampaignDetails.targeting?.radiusKm || fullCampaignDetails.radiusKm || 100

//                 }
//             });

//             // Set screen IDs if they exist
//             if (fullCampaignDetails.screenRequest) {
//                 setScreenIds(fullCampaignDetails.screenRequest.screenIds || []);
//             }
//         } else {
//             setSelectedCampaign(campaign);
//             setFormData({
//                 campaignName: campaign.campaignName || "",
//                 description: campaign.description || "",
//                 interests: campaign.interests || campaign.targeting?.interests || ["JOBS"],
//                 goal: campaign.goal || "BRANDING",
//                 medium: campaign.medium || "APP",
//                 status: campaign.status || "ACTIVE",
//                 startDate: campaign.startDate ? campaign.startDate.split('T')[0] : "",
//                 endDate: campaign.endDate ? campaign.endDate.split('T')[0] : "",
//                 city: campaign.city || campaign.targeting?.city || "",
//                 radiusKm: campaign.radiusKm || campaign.targeting?.radiusKm || 100,
//                 centerLatitude: campaign.centerLatitude || campaign.targeting?.centerLatitude || 17.3850,
//                 centerLongitude: campaign.centerLongitude || campaign.targeting?.centerLongitude || 78.4867,
//                 deepLink: campaign.deepLink || "",
//                 appType: campaign.appType || "FOOD_AND_BEVERAGES",
//                 mediaType: campaign.mediaType || "IMAGE",
//                 addDisplayPosition: campaign.addDisplayPosition || "ADD_SCREEN",
//                 customerId: campaign.customerId || "ADM161220251",
//                 paymentStatus: campaign.paymentStatus || "PENDING",
//                 loops: 7,
//                 period: "PER_DAY",
//                 targeting: {
//                     interests: campaign.targeting?.interests || campaign.interests || ["JOBS"],
//                     city: campaign.targeting?.city || campaign.city || "",
//                     centerLatitude: campaign.targeting?.centerLatitude || campaign.centerLatitude || 17.3850,
//                     centerLongitude: campaign.targeting?.centerLongitude || campaign.centerLongitude || 78.4867,
//                     radiusKm: campaign.targeting?.radiusKm || campaign.radiusKm || 100
//                 }
//             });
//         }
//         setCreativeFile(null);
//         setShowEditModal(true);
//     };

//     // MODIFIED: handleAddCampaign - Only send specified fields for DIGITAL
//     const handleAddCampaign = async (e) => {
//         e.preventDefault();

//         try {
//             showLoader();

//             const response =
//                 await createCampaignAPI({
//                     formData,
//                     creativeFile,
//                     screenIds,
//                     creativeDuration,
//                     displayPositionRatios,
//                 });

//             setCampaigns((prev) => [
//                 response,
//                 ...prev,
//             ]);

//             alert(
//                 "Campaign created successfully!"
//             );

//             resetForm();

//             setShowAddModal(false);

//         } catch (error) {
//             console.error(
//                 "❌ Error creating campaign:",
//                 error.response?.data ||
//                 error.message
//             );

//             alert(
//                 `Failed to create campaign: ${error.response?.data
//                     ?.message ||
//                 error.message
//                 }`
//             );

//         } finally {
//             hideLoader();
//         }
//     };

//     // MODIFIED: handleEditCampaign - Only send specified fields for DIGITAL
//     const handleEditCampaign = async (e) => {
//         e.preventDefault();

//         try {
//             const token = localStorage.getItem("authToken");
//             showLoader();

//             if (!token) {
//                 alert("Session expired. Please login again.");
//                 return;
//             }

//             const customerId = formData.customerId || localStorage.getItem("customerId") || "ADM161220251";

//             let campaignData;

//             if (formData.medium === "DIGITAL") {
//                 // For DIGITAL medium, only send the specified fields
//                 campaignData = {
//                     ...selectedCampaign,
//                     screenRequest: {
//                         durationSeconds: creativeDuration || selectedCampaign.screenRequest?.durationSeconds || 20,
//                         period: "PER_DAY",
//                         screenIds: screenIds.length > 0 ? screenIds : (selectedCampaign.screenRequest?.screenIds || [])
//                     },
//                     endDate: formData.endDate ? new Date(formData.endDate).toISOString() : selectedCampaign.endDate,
//                     city: formData.city || selectedCampaign.city || "",
//                     startDate: formData.startDate ? new Date(formData.startDate).toISOString() : selectedCampaign.startDate,
//                     status: formData.status,
//                     goal: formData.goal,
//                     medium: formData.medium,
//                     customerId: customerId,
//                     campaignName: formData.campaignName,
//                     description: formData.description,
//                     mediaType: formData.mediaType
//                 };
//             } else {
//                 // For other mediums, keep the existing structure
//                 const selectedPosition = formData.addDisplayPosition;
//                 const resolution = displayPositionRatios[selectedPosition]?.resolution || "R_720P";

//                 campaignData = {
//                     ...selectedCampaign,
//                     campaignName: formData.campaignName,
//                     description: formData.description,
//                     goal: formData.goal,
//                     medium: formData.medium,
//                     status: formData.status,
//                     startDate: formData.startDate ? new Date(formData.startDate).toISOString() : selectedCampaign.startDate,
//                     endDate: formData.endDate ? new Date(formData.endDate).toISOString() : selectedCampaign.endDate,
//                     customerId: customerId,
//                     appType: formData.appType,
//                     deepLink: formData.deepLink || selectedCampaign.deepLink,
//                     addDisplayPosition: formData.addDisplayPosition,
//                     resolution: resolution,
//                     mediaType: formData.mediaType,
//                     interests: formData.interests,
//                     city: formData.city || selectedCampaign.targeting?.city || "",
//                     centerLatitude: parseFloat(formData.centerLatitude) || selectedCampaign.targeting?.centerLatitude || 17.3850,
//                     centerLongitude: parseFloat(formData.centerLongitude) || selectedCampaign.targeting?.centerLongitude || 78.4867,
//                     radiusKm: parseFloat(formData.radiusKm) || selectedCampaign.targeting?.radiusKm || 100,
//                     paymentStatus: formData.paymentStatus || selectedCampaign.paymentStatus || "PENDING",
//                     targeting: {
//                         interests: formData.interests,
//                         city: formData.city || selectedCampaign.targeting?.city || "",
//                         centerLatitude: parseFloat(formData.centerLatitude) || selectedCampaign.targeting?.centerLatitude || 17.3850,
//                         centerLongitude: parseFloat(formData.centerLongitude) || selectedCampaign.targeting?.centerLongitude || 78.4867,
//                         radiusKm: parseFloat(formData.radiusKm) || selectedCampaign.targeting?.radiusKm || 100
//                     }
//                 };
//             }

//             console.log("Updating campaign:", campaignData);

//             setCampaigns(prev =>
//                 prev.map(campaign =>
//                     campaign.id === selectedCampaign.id || campaign.campaignId === selectedCampaign.id
//                         ? campaignData
//                         : campaign
//                 )
//             );

//             if (viewCampaign && (viewCampaign.id === selectedCampaign.id || viewCampaign.campaignId === selectedCampaign.id)) {
//                 setViewCampaign(campaignData);
//             }

//             alert("Campaign updated successfully!");
//             setShowEditModal(false);
//             setSelectedCampaign(null);
//             resetForm();

//         } catch (error) {
//             console.error("❌ Error updating campaign:", error.response?.data || error.message);
//             alert(`Failed to update campaign: ${error.response?.data?.message || error.message}`);
//         } finally {
//             hideLoader();
//         }
//     };

//     const resetForm = () => {
//         setFormData({
//             campaignName: "",
//             description: "",
//             interests: ["JOBS"],
//             goal: "BRANDING",
//             medium: "APP",
//             status: "ACTIVE",
//             startDate: "",
//             endDate: "",
//             city: "",
//             radiusKm: 100,
//             centerLatitude: 17.3850,
//             centerLongitude: 78.4867,
//             deepLink: "",
//             appType: "FOOD_AND_BEVERAGES",
//             mediaType: "IMAGE",
//             addDisplayPosition: "ADD_SCREEN",
//             customerId: "ADM161220251",
//             paymentStatus: "PENDING",
//             loops: 7,
//             period: "PER_DAY",
//             targeting: {
//                 interests: ["JOBS"],
//                 city: "",
//                 centerLatitude: 17.3850,
//                 centerLongitude: 78.4867,
//                 radiusKm: 100
//             }
//         });
//         setCreativeFile(null);
//         setCreativeResolution(null);
//         setCreativeDuration(null);
//         setCreativeValidationMessages([]);
//         setScreenIds([]);
//     };

//     const formatDate = (dateString) => {
//         if (!dateString) return "-";
//         const date = new Date(dateString);
//         return date.toLocaleDateString("en-GB", {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric'
//         }).replace(/\//g, '-');
//     };

//     const formatDateTime = (dateString) => {
//         if (!dateString) return "-";
//         const date = new Date(dateString);
//         return date.toLocaleString("en-GB", {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric',
//             hour: '2-digit',
//             minute: '2-digit',
//             second: '2-digit'
//         });
//     };

//     const getStatusColor = (status) => {
//         const colors = {
//             'DRAFT': '#9E9E9E',
//             'SCHEDULED': '#FF9800',
//             'ACTIVE': '#4CAF50',
//             'PAUSED': '#FFC107',
//             'COMPLETED': '#2196F3',
//             'CANCELLED': '#f44336'
//         };
//         return colors[status] || '#9E9E9E';
//     };

//     const getApprovalStatusColor = (status) => {
//         const colors = {
//             'PENDING': '#FF9800',
//             'APPROVED': '#4CAF50',
//             'REJECTED': '#f44336'
//         };
//         return colors[status] || '#9E9E9E';
//     };

//     const getPaymentStatusColor = (status) => {
//         const colors = {
//             'PENDING': '#FF9800',
//             'PAID': '#4CAF50',
//             'FAILED': '#f44336',
//             'REFUNDED': '#9C27B0',
//             'CANCELLED': '#9E9E9E'
//         };
//         return colors[status] || '#9E9E9E';
//     };

//     const openMediaPreview = (url) => {
//         if (!url) return;
//         const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv'];
//         const extension = url.split('.').pop()?.toLowerCase().split('?')[0];
//         const isVideo = videoExtensions.includes(extension) || url.includes('video') || url.includes('mp4');

//         console.log("Opening media:", { url, extension, isVideo });

//         setPreviewMediaUrl(url);
//         setPreviewMediaType(isVideo ? 'video' : 'image');
//         setShowMediaPreview(true);
//     };

//     const closeMediaPreview = () => {
//         setShowMediaPreview(false);
//         setPreviewMediaUrl('');
//         setPreviewMediaType('');
//     };

//     const modalOverlayStyle = {
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         backgroundColor: 'rgba(0, 0, 0, 0.5)',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         zIndex: 9999,
//         padding: isMobile ? '10px' : '20px',
//         overflow: 'auto',
//     };

//     const modalContentStyle = {
//         backgroundColor: '#fff',
//         borderRadius: '8px',
//         width: '100%',
//         maxWidth: isMobile ? '95%' : '600px',
//         maxHeight: '90vh',
//         overflowY: 'auto',
//         boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
//         animation: 'fadeIn 0.3s ease-out',
//     };

//     const modalHeaderStyle = {
//         padding: isMobile ? '15px' : '20px',
//         borderBottom: '1px solid #eee',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         position: 'sticky',
//         top: 0,
//         backgroundColor: '#fff',
//         zIndex: 10,
//     };

//     const modalBodyStyle = {
//         padding: isMobile ? '15px' : '20px',
//     };

//     const tdStyle = {
//         border: "1px solid #ccc",
//         padding: "10px",
//         textAlign: "left"
//     };

//     useEffect(() => {
//         const style = document.createElement('style');
//         style.textContent = `
//             @keyframes fadeIn {
//                 from {
//                     opacity: 0;
//                     transform: translateY(-20px);
//                 }
//                 to {
//                     opacity: 1;
//                     transform: translateY(0);
//                 }
//             }

//             @keyframes fadeOut {
//                 from {
//                     opacity: 1;
//                     transform: translateY(0);
//                 }
//                 to {
//                     opacity: 0;
//                     transform: translateY(-20px);
//                 }
//             }

//             @keyframes spin {
//                 0% { transform: rotate(0deg); }
//                 100% { transform: rotate(360deg); }
//             }

//             .modal-enter {
//                 animation: fadeIn 0.3s ease-out;
//             }

//             .modal-exit {
//                 animation: fadeOut 0.3s ease-out;
//             }
//         `;
//         document.head.appendChild(style);

//         return () => {
//             document.head.removeChild(style);
//         };
//     }, []);

//     return (
//         <div
//             style={{
//                 maxWidth: '1400px',
//                 width: '100%',
//                 margin: '0 auto',
//                 padding: isMobile ? '15px' : '20px',
//                 position: 'relative',
//             }}
//         >
//             {/* Media Preview Modal */}
//             {showMediaPreview && (
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     backgroundColor: 'rgba(0, 0, 0, 0.9)',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     zIndex: 10000,
//                     padding: '20px',
//                 }} onClick={closeMediaPreview}>
//                     <div style={{
//                         position: 'relative',
//                         maxWidth: '90%',
//                         maxHeight: '90%',
//                     }} onClick={e => e.stopPropagation()}>
//                         <button
//                             style={{
//                                 position: 'absolute',
//                                 top: '-40px',
//                                 right: '-40px',
//                                 background: 'white',
//                                 border: 'none',
//                                 borderRadius: '50%',
//                                 width: '40px',
//                                 height: '40px',
//                                 fontSize: '20px',
//                                 cursor: 'pointer',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 zIndex: 10001,
//                             }}
//                             onClick={closeMediaPreview}
//                         >
//                             ✕
//                         </button>
//                         {previewMediaType === 'video' ? (
//                             <video
//                                 key={previewMediaUrl}
//                                 controls
//                                 autoPlay
//                                 style={{
//                                     maxWidth: '100%',
//                                     maxHeight: '80vh',
//                                     borderRadius: '8px',
//                                 }}
//                             >
//                                 <source src={previewMediaUrl} type="video/mp4" />
//                                 <source src={previewMediaUrl} type="video/webm" />
//                                 <source src={previewMediaUrl} type="video/ogg" />
//                                 Your browser does not support the video tag.
//                             </video>
//                         ) : (
//                             <img
//                                 src={previewMediaUrl}
//                                 alt="Preview"
//                                 style={{
//                                     maxWidth: '100%',
//                                     maxHeight: '80vh',
//                                     borderRadius: '8px',
//                                 }}
//                             />
//                         )}
//                     </div>
//                 </div>
//             )}

//             {/* Approval Modal */}
//             {showApprovalModal && selectedCampaignForApproval && (
//                 <div style={modalOverlayStyle} onClick={(e) => {
//                     if (e.target === e.currentTarget) {
//                         setShowApprovalModal(false);
//                         setSelectedCampaignForApproval(null);
//                         setApprovalData({
//                             campaignId: null,
//                             approvalStatus: "PENDING",
//                             rejectionReason: ""
//                         });
//                     }
//                 }}>
//                     <div style={modalContentStyle} className="modal-enter">
//                         <div style={modalHeaderStyle}>
//                             <h3 style={{
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 fontWeight: 'bold',
//                                 margin: 0,
//                                 color: '#333'
//                             }}>
//                                 {approvalData.approvalStatus === "REJECTED" ? "Reject Campaign" : "Update Campaign Approval"}
//                             </h3>
//                             <button
//                                 style={{
//                                     background: 'transparent',
//                                     border: 'none',
//                                     fontSize: '20px',
//                                     cursor: 'pointer',
//                                     color: '#666',
//                                     fontWeight: 'bold',
//                                     padding: '0',
//                                     width: '30px',
//                                     height: '30px',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     borderRadius: '4px',
//                                 }}
//                                 onClick={() => {
//                                     setShowApprovalModal(false);
//                                     setSelectedCampaignForApproval(null);
//                                     setApprovalData({
//                                         campaignId: null,
//                                         approvalStatus: "PENDING",
//                                         rejectionReason: ""
//                                     });
//                                 }}
//                                 onMouseOver={e => e.target.style.backgroundColor = '#f0f0f0'}
//                                 onMouseOut={e => e.target.style.backgroundColor = 'transparent'}
//                             >
//                                 ✕
//                             </button>
//                         </div>

//                         <div style={modalBodyStyle}>
//                             <form onSubmit={handleApprovalUpdate}>
//                                 <div style={{ marginBottom: '20px' }}>
//                                     <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '10px', fontSize: '15px' }}>
//                                         Campaign: {selectedCampaignForApproval.campaignName}
//                                     </h4>
//                                     <p style={{ fontSize: '13px', color: '#666', marginBottom: '15px' }}>
//                                         ID: {selectedCampaignForApproval.id || selectedCampaignForApproval.campaignId}
//                                     </p>
//                                 </div>

//                                 {approvalData.approvalStatus !== "REJECTED" && (
//                                     <div style={{ marginBottom: '20px' }}>
//                                         <label style={labelStyle}>Approval Status *</label>
//                                         <select
//                                             name="approvalStatus"
//                                             value={approvalData.approvalStatus}
//                                             onChange={handleApprovalChange}
//                                             required
//                                             style={inputStyle}
//                                         >
//                                             {approvalStatusOptions.map((option) => (
//                                                 <option key={option} value={option}>
//                                                     {option}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </div>
//                                 )}

//                                 {approvalData.approvalStatus === "REJECTED" && (
//                                     <div style={{ marginBottom: '20px' }}>
//                                         <label style={labelStyle}>Rejection Reason *</label>
//                                         <textarea
//                                             name="rejectionReason"
//                                             placeholder="Please provide reason for rejection"
//                                             value={approvalData.rejectionReason}
//                                             onChange={handleApprovalChange}
//                                             required={approvalData.approvalStatus === "REJECTED"}
//                                             rows="4"
//                                             style={{ ...inputStyle, resize: 'vertical' }}
//                                         />
//                                     </div>
//                                 )}

//                                 <div style={{
//                                     marginBottom: '20px',
//                                     padding: '12px',
//                                     backgroundColor: '#f5f5f5',
//                                     borderRadius: '4px'
//                                 }}>
//                                     <strong style={{ display: 'block', marginBottom: '5px' }}>Current Approval Status:</strong>
//                                     <span style={{
//                                         padding: "4px 8px",
//                                         borderRadius: "4px",
//                                         backgroundColor: getApprovalStatusColor(selectedCampaignForApproval.approvalStatus || 'PENDING'),
//                                         color: "white",
//                                         fontSize: "12px",
//                                         fontWeight: "500",
//                                         display: 'inline-block'
//                                     }}>
//                                         {selectedCampaignForApproval.approvalStatus || 'PENDING'}
//                                     </span>
//                                 </div>

//                                 <div style={{
//                                     display: 'flex',
//                                     gap: '10px',
//                                     marginTop: '20px',
//                                     position: 'sticky',
//                                     bottom: 0,
//                                     backgroundColor: '#fff',
//                                     padding: '10px 0',
//                                     borderTop: '1px solid #eee'
//                                 }}>
//                                     <button
//                                         type="submit"
//                                         style={{
//                                             padding: '12px',
//                                             backgroundColor: approvalData.approvalStatus === "REJECTED" ? '#f44336' : 'rgb(230 109 51)',
//                                             color: 'white',
//                                             fontWeight: '600',
//                                             border: 'none',
//                                             borderRadius: '6px',
//                                             cursor: 'pointer',
//                                             flex: 1,
//                                             fontSize: '14px',
//                                         }}
//                                         onMouseOver={e => e.target.style.backgroundColor = approvalData.approvalStatus === "REJECTED" ? '#d32f2f' : '#9b4ab9'}
//                                         onMouseOut={e => e.target.style.backgroundColor = approvalData.approvalStatus === "REJECTED" ? '#f44336' : 'rgb(230 109 51)'}
//                                     >
//                                         {approvalData.approvalStatus === "REJECTED" ? 'Reject Campaign' : 'Update Approval Status'}
//                                     </button>
//                                     <button
//                                         type="button"
//                                         style={{
//                                             padding: '12px',
//                                             backgroundColor: '#f5f5f5',
//                                             color: '#333',
//                                             fontWeight: '600',
//                                             border: '1px solid #ddd',
//                                             borderRadius: '6px',
//                                             cursor: 'pointer',
//                                             flex: 1,
//                                             fontSize: '14px',
//                                         }}
//                                         onClick={() => {
//                                             setShowApprovalModal(false);
//                                             setSelectedCampaignForApproval(null);
//                                             setApprovalData({
//                                                 campaignId: null,
//                                                 approvalStatus: "PENDING",
//                                                 rejectionReason: ""
//                                             });
//                                         }}
//                                         onMouseOver={e => e.target.style.backgroundColor = '#e0e0e0'}
//                                         onMouseOut={e => e.target.style.backgroundColor = '#f5f5f5'}
//                                     >
//                                         Cancel
//                                     </button>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 </div>
//             )}


//             {showViewModal && viewCampaign && (
//                 <div style={modalOverlayStyle} onClick={(e) => {
//                     if (e.target === e.currentTarget) {
//                         setShowViewModal(false);
//                         setViewCampaign(null);
//                         setShowRejectionInput(false);
//                         setRejectionReason('');
//                     }
//                 }}>
//                     <div style={modalContentStyle} className="modal-enter">
//                         <div style={modalHeaderStyle}>
//                             <h3 style={{
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 fontWeight: 'bold',
//                                 margin: 0,
//                                 color: '#333'
//                             }}>
//                                 Campaign Details
//                             </h3>
//                             <button
//                                 style={{
//                                     background: 'transparent',
//                                     border: 'none',
//                                     fontSize: '20px',
//                                     cursor: 'pointer',
//                                     color: '#666',
//                                     fontWeight: 'bold',
//                                     padding: '0',
//                                     width: '30px',
//                                     height: '30px',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     borderRadius: '4px',
//                                 }}
//                                 onClick={() => {
//                                     setShowViewModal(false);
//                                     setViewCampaign(null);
//                                     setShowRejectionInput(false);
//                                     setRejectionReason('');
//                                 }}
//                                 onMouseOver={e => e.target.style.backgroundColor = '#f0f0f0'}
//                                 onMouseOut={e => e.target.style.backgroundColor = 'transparent'}
//                             >
//                                 ✕
//                             </button>
//                         </div>

//                         <div style={modalBodyStyle}>
//                             <div style={{ marginBottom: '20px' }}>
//                                 <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '15px', fontSize: '16px' }}>Basic Information</h4>
//                                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '10px', fontSize: '14px' }}>
//                                     <strong>ID:</strong> <span>{viewCampaign.id || viewCampaign.campaignId}</span>
//                                     <strong>Promotion Name:</strong> <span>{viewCampaign.campaignName}</span>
//                                     <strong>Description:</strong> <span>{viewCampaign.description}</span>
//                                     <strong>Goal:</strong> <span>{viewCampaign.goal}</span>
//                                     <strong>Medium:</strong> <span>{viewCampaign.medium}</span>
//                                     <strong>Status:</strong>
//                                     <span>
//                                         <span style={{
//                                             padding: "4px 8px",
//                                             borderRadius: "4px",
//                                             backgroundColor: getStatusColor(viewCampaign.status),
//                                             color: "white",
//                                             fontSize: "12px",
//                                             fontWeight: "500",
//                                             display: 'inline-block'
//                                         }}>
//                                             {viewCampaign.status}
//                                         </span>
//                                     </span>
//                                     <strong>Approval Status:</strong>
//                                     <span>
//                                         <span style={{
//                                             padding: "4px 8px",
//                                             borderRadius: "4px",
//                                             backgroundColor: getApprovalStatusColor(viewCampaign.approvalStatus || 'PENDING'),
//                                             color: "white",
//                                             fontSize: "12px",
//                                             fontWeight: "500",
//                                             display: 'inline-block'
//                                         }}>
//                                             {viewCampaign.approvalStatus || 'PENDING'}
//                                         </span>
//                                     </span>
//                                     <strong>Payment Status:</strong>
//                                     <span>
//                                         <span style={{
//                                             padding: "4px 8px",
//                                             borderRadius: "4px",
//                                             backgroundColor: getPaymentStatusColor(viewCampaign.paymentStatus || 'PENDING'),
//                                             color: "white",
//                                             fontSize: "12px",
//                                             fontWeight: "500",
//                                             display: 'inline-block'
//                                         }}>
//                                             {viewCampaign.paymentStatus || 'PENDING'}
//                                         </span>
//                                     </span>
//                                 </div>
//                             </div>

//                             <div style={{ marginBottom: '20px' }}>
//                                 <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '15px', fontSize: '16px' }}>Dates</h4>
//                                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '10px', fontSize: '14px' }}>
//                                     <strong>Start Date:</strong> <span>{formatDateTime(viewCampaign.startDate)}</span>
//                                     <strong>End Date:</strong> <span>{formatDateTime(viewCampaign.endDate)}</span>
//                                     <strong>Created At:</strong> <span>{formatDateTime(viewCampaign.createdAt)}</span>
//                                     <strong>Updated At:</strong> <span>{viewCampaign.updatedAt ? formatDateTime(viewCampaign.updatedAt) : 'Not updated'}</span>
//                                 </div>
//                             </div>

//                             <div style={{ marginBottom: '20px' }}>
//                                 <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '15px', fontSize: '16px' }}>Targeting</h4>
//                                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '10px', fontSize: '14px' }}>
//                                     <strong>Interests:</strong>
//                                     <span>
//                                         {viewCampaign.targeting?.interests && viewCampaign.targeting.interests.length > 0
//                                             ? viewCampaign.targeting.interests.join(', ')
//                                             : viewCampaign.interests && viewCampaign.interests.length > 0
//                                                 ? viewCampaign.interests.join(', ')
//                                                 : 'None'}
//                                     </span>
//                                     <strong>City:</strong> <span>{viewCampaign.city || viewCampaign.targeting?.city || 'Not specified'}</span>
//                                     <strong>Center Latitude:</strong> <span>{viewCampaign.centerLatitude || viewCampaign.targeting?.centerLatitude || 'Not specified'}</span>
//                                     <strong>Center Longitude:</strong> <span>{viewCampaign.centerLongitude || viewCampaign.targeting?.centerLongitude || 'Not specified'}</span>
//                                     <strong>Radius:</strong> <span>{viewCampaign.radiusKm || viewCampaign.targeting?.radiusKm ? `${viewCampaign.radiusKm || viewCampaign.targeting?.radiusKm} km` : 'Not specified'}</span>
//                                 </div>
//                             </div>

//                             <div style={{ marginBottom: '20px' }}>
//                                 <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '15px', fontSize: '16px' }}>Campaign Details</h4>
//                                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '10px', fontSize: '14px' }}>
//                                     <strong>App Type:</strong> <span>{viewCampaign.appType}</span>
//                                     <strong>Deep Link:</strong> <span>{viewCampaign.deepLink || 'Not specified'}</span>
//                                     <strong>Add Display Position:</strong> <span>{viewCampaign.addDisplayPosition}</span>
//                                     <strong>Resolution:</strong> <span>{viewCampaign.resolution || 'Auto-set'}</span>
//                                     <strong>Media Type:</strong> <span>{viewCampaign.mediaType || 'Not specified'}</span>
//                                     <strong>Customer ID:</strong> <span>{viewCampaign.customerId}</span>
//                                 </div>
//                             </div>
//                             {/* Coupon Details */}
//                             {viewCampaign.goal === "DISCOUNT" &&
//                                 viewCampaign.subGoal === "COUPONS" &&
//                                 viewCampaign.vendorCouponRequest && (
//                                     <div style={{ marginBottom: '20px' }}>
//                                         <h4
//                                             style={{
//                                                 color: 'rgb(230 109 51)',
//                                                 marginBottom: '15px',
//                                                 fontSize: '16px'
//                                             }}
//                                         >
//                                             Coupon Details
//                                         </h4>

//                                         <div
//                                             style={{
//                                                 display: 'grid',
//                                                 gridTemplateColumns: '1fr 2fr',
//                                                 gap: '10px',
//                                                 fontSize: '14px'
//                                             }}
//                                         >
//                                             <strong>Coupon Code:</strong>
//                                             <span>
//                                                 {viewCampaign.vendorCouponRequest.couponCode || '-'}
//                                             </span>

//                                             <strong>Discount:</strong>
//                                             <span>
//                                                 {viewCampaign.vendorCouponRequest.discount || 0}%
//                                             </span>

//                                             <strong>Discount Type:</strong>
//                                             <span>
//                                                 {viewCampaign.vendorCouponRequest.discountType || '-'}
//                                             </span>

//                                             <strong>Coupon Type:</strong>
//                                             <span>
//                                                 {viewCampaign.vendorCouponRequest.couponType || '-'}
//                                             </span>

//                                             <strong>Minimum Order Value:</strong>
//                                             <span>
//                                                 ₹{viewCampaign.vendorCouponRequest.minimumOrderValue || 0}
//                                             </span>

//                                             <strong>Start Time:</strong>
//                                             <span>
//                                                 {viewCampaign.vendorCouponRequest.startTime || 'N/A'}
//                                             </span>

//                                             <strong>End Time:</strong>
//                                             <span>
//                                                 {viewCampaign.vendorCouponRequest.endTime || 'N/A'}
//                                             </span>
//                                         </div>
//                                     </div>
//                                 )}

//                             {/* Show Digital Screen Settings if medium is DIGITAL */}
//                             {viewCampaign.medium === "DIGITAL" && viewCampaign.screenRequest && (
//                                 <div style={{ marginBottom: '20px' }}>
//                                     <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '15px', fontSize: '16px' }}>Digital Screen Settings</h4>
//                                     <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '10px', fontSize: '14px' }}>
//                                         <strong>Duration Seconds:</strong>
//                                         <span>{viewCampaign.screenRequest.durationSeconds || 20}s</span>
//                                         <strong>Period:</strong>
//                                         <span>{viewCampaign.screenRequest.period || 'PER_DAY'}</span>
//                                         <strong>Screen IDs:</strong>
//                                         <span>
//                                             {viewCampaign.screenRequest.screenIds && viewCampaign.screenRequest.screenIds.length > 0
//                                                 ? viewCampaign.screenRequest.screenIds.join(', ')
//                                                 : 'None'}
//                                         </span>
//                                     </div>
//                                 </div>
//                             )}

//                             <div style={{ marginBottom: '20px' }}>
//                                 <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '15px', fontSize: '16px' }}>Statistics</h4>
//                                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '10px', fontSize: '14px' }}>
//                                     <strong>Total Budget:</strong> <span>₹{viewCampaign.totalBudget?.toFixed(2) || '0.00'}</span>
//                                     <strong>Likes Count:</strong> <span>{viewCampaign.likesCount || 0}</span>
//                                     <strong>Views Count:</strong> <span>{viewCampaign.viewsCount || 0}</span>
//                                     <strong>Shares Count:</strong> <span>{viewCampaign.sharesCount || 0}</span>
//                                     <strong>Saves Count:</strong> <span>{viewCampaign.savesCount || 0}</span>
//                                     <strong>Comments Count:</strong> <span>{viewCampaign.commentsCount || 0}</span>
//                                 </div>
//                             </div>

//                             {viewCampaign.imageUrl && (
//                                 <div style={{ marginBottom: '20px' }}>
//                                     <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '15px', fontSize: '16px' }}>Creative</h4>
//                                     <button
//                                         onClick={() => openMediaPreview(viewCampaign.imageUrl)}
//                                         style={{
//                                             backgroundColor: "#4CAF50",
//                                             color: "white",
//                                             border: "none",
//                                             padding: "10px 16px",
//                                             borderRadius: "4px",
//                                             cursor: "pointer",
//                                             fontSize: "14px",
//                                             fontWeight: "500",
//                                         }}
//                                         onMouseOver={e => e.target.style.backgroundColor = '#45a049'}
//                                         onMouseOut={e => e.target.style.backgroundColor = '#4CAF50'}
//                                     >
//                                         View Creative
//                                     </button>
//                                 </div>
//                             )}

//                             {/* Approval Actions */}
//                             <div style={{
//                                 marginTop: '20px',
//                                 padding: '15px',
//                                 backgroundColor: '#f8f9fa',
//                                 borderRadius: '6px',
//                                 border: '1px solid #e0e0e0'
//                             }}>
//                                 <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '10px', fontSize: '14px' }}>Approval Actions</h4>

//                                 {/* Show rejection reason input when rejecting */}
//                                 {showRejectionInput ? (
//                                     <div style={{ marginBottom: '15px' }}>
//                                         <label style={{ ...labelStyle, fontSize: '13px', marginBottom: '8px' }}>
//                                             Rejection Reason *
//                                         </label>
//                                         <textarea
//                                             placeholder="Please provide reason for rejection"
//                                             value={rejectionReason}
//                                             onChange={(e) => setRejectionReason(e.target.value)}
//                                             rows="3"
//                                             style={{
//                                                 ...inputStyle,
//                                                 resize: 'vertical',
//                                                 fontSize: '13px',
//                                                 padding: '8px',
//                                                 marginBottom: '10px'
//                                             }}
//                                         />
//                                         <div style={{
//                                             display: 'flex',
//                                             gap: '10px',
//                                             justifyContent: 'flex-end'
//                                         }}>
//                                             <button
//                                                 style={{
//                                                     backgroundColor: "#f44336",
//                                                     color: "white",
//                                                     border: "none",
//                                                     padding: "6px 12px",
//                                                     borderRadius: "4px",
//                                                     cursor: "pointer",
//                                                     fontSize: "12px",
//                                                     fontWeight: "500",
//                                                 }}
//                                                 onClick={() => {
//                                                     if (!rejectionReason.trim()) {
//                                                         alert("Please provide a rejection reason");
//                                                         return;
//                                                     }
//                                                     handleDirectReject(viewCampaign);
//                                                 }}
//                                                 onMouseOver={e => e.target.style.backgroundColor = '#d32f2f'}
//                                                 onMouseOut={e => e.target.style.backgroundColor = '#f44336'}
//                                             >
//                                                 Submit Rejection
//                                             </button>
//                                             <button
//                                                 style={{
//                                                     backgroundColor: "#9e9e9e",
//                                                     color: "white",
//                                                     border: "none",
//                                                     padding: "6px 12px",
//                                                     borderRadius: "4px",
//                                                     cursor: "pointer",
//                                                     fontSize: "12px",
//                                                     fontWeight: "500",
//                                                 }}
//                                                 onClick={() => {
//                                                     setShowRejectionInput(false);
//                                                     setRejectionReason('');
//                                                 }}
//                                                 onMouseOver={e => e.target.style.backgroundColor = '#757575'}
//                                                 onMouseOut={e => e.target.style.backgroundColor = '#9e9e9e'}
//                                             >
//                                                 Cancel
//                                             </button>
//                                         </div>
//                                     </div>
//                                 ) : (
//                                     <div style={{
//                                         display: 'flex',
//                                         gap: '10px',
//                                         flexWrap: 'wrap',
//                                         justifyContent: 'center'
//                                     }}>
//                                         {/* Approve Button */}
//                                         <button
//                                             style={{
//                                                 backgroundColor: "#4CAF50",
//                                                 color: "white",
//                                                 border: "none",
//                                                 padding: "8px 16px",
//                                                 borderRadius: "4px",
//                                                 cursor: "pointer",
//                                                 fontSize: "12px",
//                                                 fontWeight: "500",
//                                                 flex: '0 1 auto',
//                                                 minWidth: '100px',
//                                                 opacity: viewCampaign.approvalStatus === 'APPROVED' ? 0.5 : 1
//                                             }}
//                                             onClick={() => handleDirectApprove(viewCampaign)}
//                                             disabled={viewCampaign.approvalStatus === 'APPROVED'}
//                                             onMouseOver={e => {
//                                                 if (viewCampaign.approvalStatus !== 'APPROVED') {
//                                                     e.target.style.backgroundColor = '#45a049';
//                                                 }
//                                             }}
//                                             onMouseOut={e => {
//                                                 if (viewCampaign.approvalStatus !== 'APPROVED') {
//                                                     e.target.style.backgroundColor = '#4CAF50';
//                                                 }
//                                             }}
//                                         >
//                                             {viewCampaign.approvalStatus === 'APPROVED' ? '✓ Already Approved' : 'Approve Campaign'}
//                                         </button>

//                                         {/* Reject Button */}
//                                         <button
//                                             style={{
//                                                 backgroundColor: "#f44336",
//                                                 color: "white",
//                                                 border: "none",
//                                                 padding: "8px 16px",
//                                                 borderRadius: "4px",
//                                                 cursor: "pointer",
//                                                 fontSize: "12px",
//                                                 fontWeight: "500",
//                                                 flex: '0 1 auto',
//                                                 minWidth: '100px',
//                                                 opacity: viewCampaign.approvalStatus === 'REJECTED' ? 0.5 : 1
//                                             }}
//                                             onClick={() => {
//                                                 if (viewCampaign.approvalStatus !== 'REJECTED') {
//                                                     setShowRejectionInput(true);
//                                                 }
//                                             }}
//                                             disabled={viewCampaign.approvalStatus === 'REJECTED'}
//                                             onMouseOver={e => {
//                                                 if (viewCampaign.approvalStatus !== 'REJECTED') {
//                                                     e.target.style.backgroundColor = '#d32f2f';
//                                                 }
//                                             }}
//                                             onMouseOut={e => {
//                                                 if (viewCampaign.approvalStatus !== 'REJECTED') {
//                                                     e.target.style.backgroundColor = '#f44336';
//                                                 }
//                                             }}
//                                         >
//                                             {viewCampaign.approvalStatus === 'REJECTED' ? '✗ Already Rejected' : 'Reject Campaign'}
//                                         </button>
//                                     </div>
//                                 )}

//                                 <p style={{
//                                     fontSize: '11px',
//                                     color: '#666',
//                                     marginTop: '8px',
//                                     textAlign: 'center',
//                                     fontStyle: 'italic'
//                                 }}>
//                                     {viewCampaign.approvalStatus === 'APPROVED'
//                                         ? 'This campaign has already been approved.'
//                                         : viewCampaign.approvalStatus === 'REJECTED'
//                                             ? 'This campaign has already been rejected.'
//                                             : showRejectionInput
//                                                 ? 'Please provide a reason for rejection'
//                                                 : 'Approve this campaign to make it active or reject with a reason.'}
//                                 </p>
//                             </div>

//                             {/* Close Button */}
//                             <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
//                                 <button
//                                     style={{
//                                         padding: '10px 20px',
//                                         backgroundColor: '#9e9e9e',
//                                         color: 'white',
//                                         fontWeight: '600',
//                                         border: 'none',
//                                         borderRadius: '6px',
//                                         cursor: 'pointer',
//                                         fontSize: '14px',
//                                     }}
//                                     onClick={() => {
//                                         setShowViewModal(false);
//                                         setViewCampaign(null);
//                                         setShowRejectionInput(false);
//                                         setRejectionReason('');
//                                     }}
//                                     onMouseOver={e => e.target.style.backgroundColor = '#757575'}
//                                     onMouseOut={e => e.target.style.backgroundColor = '#9e9e9e'}
//                                 >
//                                     Close
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Create Campaign Button */}
//             {/* <div style={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 marginBottom: '20px',
//                 flexWrap: 'wrap',
//                 gap: '10px'
//              }}>
//                 <button
//                     style={{
//                         padding: isMobile ? '8px 14px' : '10px 16px',
//                         backgroundColor: '#1976d2',
//                         color: '#fff',
//                         border: 'none',
//                         borderRadius: '6px',
//                         cursor: 'pointer',
//                         fontWeight: 'bold',
//                         fontSize: isMobile ? '13px' : '14px',
//                         transition: 'background-color 0.3s',
//                     }}
//                     onClick={() => {
//                         resetForm();
//                         setShowAddModal(true);
//                     }}
//                     onMouseOver={e => e.target.style.backgroundColor = '#1565c0'}
//                     onMouseOut={e => e.target.style.backgroundColor = '#1976d2'}
//                 >
//                     + Create Promotions
//                 </button>
//             </div> */}

//             {/* Table Section */}
//             <div style={{
//                 overflowX: 'auto',
//                 overflowY: 'auto',
//                 width: '100%',
//                 maxHeight: '63vh',
//                 maxWidth: '1220px',
//                 backgroundColor: 'white',
//                 borderRadius: '8px',
//                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//                 border: '1px solid #e0e0e0',
//             }}>
//                 <table
//                     style={{
//                         width: "100%",
//                         borderCollapse: "collapse",
//                         minWidth: '1500px',
//                     }}
//                 >
//                     <thead>
//                         <tr>
//                             {[
//                                 "S.No",
//                                 "Promotion Name",
//                                 "Description",
//                                 "Interests",
//                                 "Goal",
//                                 "Medium",
//                                 "Campaign Status",
//                                 "Approval Status",
//                                 "Payment Status",
//                                 "Start Date",
//                                 "End Date",
//                                 "City",
//                                 "Radius",
//                                 "App Type",
//                                 "Media Type",
//                                 "Display Position",
//                                 "Resolution",
//                                 "Customer ID",
//                                 "Creative",
//                                 "Actions",
//                             ].map((head, i) => (
//                                 <th
//                                     key={i}
//                                     style={{
//                                         border: "1px solid #e0e0e0",
//                                         padding: isMobile ? "8px" : "12px",
//                                         backgroundColor: "rgb(230 109 51)",
//                                         fontSize: isMobile ? "12px" : "14px",
//                                         textAlign: "center",
//                                         whiteSpace: "nowrap",
//                                         color: "white",
//                                         fontWeight: "600",
//                                         position: "sticky",
//                                         top: 0,
//                                         zIndex: 10,
//                                     }}
//                                 >
//                                     {head}
//                                 </th>
//                             ))}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {loading ? (
//                             <tr>
//                                 <td colSpan="20" style={{ textAlign: "center", padding: "40px" }}>
//                                     <div style={{
//                                         display: 'flex',
//                                         justifyContent: 'center',
//                                         alignItems: 'center',
//                                         flexDirection: 'column',
//                                         gap: '10px'
//                                     }}>
//                                         <div style={{
//                                             width: '40px',
//                                             height: '40px',
//                                             border: '3px solid #f3f3f3',
//                                             borderTop: '3px solid rgb(230 109 51)',
//                                             borderRadius: '50%',
//                                             animation: 'spin 1s linear infinite'
//                                         }}></div>
//                                         <span style={{ color: '#666' }}>Loading campaigns...</span>
//                                     </div>
//                                 </td>
//                             </tr>
//                         ) : campaigns.length === 0 ? (
//                             <tr>
//                                 <td colSpan="20" style={{ textAlign: "center", padding: "40px" }}>
//                                     <div style={{
//                                         display: 'flex',
//                                         flexDirection: 'column',
//                                         alignItems: 'center',
//                                         gap: '15px',
//                                         color: '#666'
//                                     }}>
//                                         <span>No campaigns found.</span>
//                                         <button
//                                             onClick={() => {
//                                                 resetForm();
//                                                 setShowAddModal(true);
//                                             }}
//                                             style={{
//                                                 padding: '8px 16px',
//                                                 backgroundColor: '#1976d2',
//                                                 color: 'white',
//                                                 border: 'none',
//                                                 borderRadius: '4px',
//                                                 cursor: 'pointer',
//                                                 fontWeight: '500'
//                                             }}
//                                         >
//                                             Create Your First Campaign
//                                         </button>
//                                     </div>
//                                 </td>
//                             </tr>
//                         ) : (
//                             campaigns.map((campaign, index) => (
//                                 <tr key={campaign.id || campaign.campaignId || index} style={{
//                                     backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white',
//                                     transition: 'background-color 0.2s',
//                                 }}>
//                                     <td style={tdStyle}>{index + 1}</td>
//                                     <td style={tdStyle}>{campaign.campaignName || "-"}</td>
//                                     <td style={tdStyle}>{campaign.description || "-"}</td>
//                                     <td style={tdStyle}>
//                                         <span style={{
//                                             padding: "4px 8px",
//                                             borderRadius: "4px",
//                                             backgroundColor: "#607d8b",
//                                             color: "white",
//                                             fontSize: "12px",
//                                             fontWeight: "500",
//                                             display: 'inline-block'
//                                         }}>
//                                             {campaign.interests && campaign.interests.length > 0
//                                                 ? campaign.interests.join(', ')
//                                                 : campaign.targeting?.interests && campaign.targeting.interests.length > 0
//                                                     ? campaign.targeting.interests.join(', ')
//                                                     : "-"}
//                                         </span>
//                                     </td>
//                                     <td style={tdStyle}>{campaign.goal || "-"}</td>
//                                     <td style={tdStyle}>{campaign.medium || "-"}</td>
//                                     <td style={tdStyle}>
//                                         <span style={{
//                                             padding: "4px 8px",
//                                             borderRadius: "4px",
//                                             backgroundColor: getStatusColor(campaign.status),
//                                             color: "white",
//                                             fontSize: "12px",
//                                             fontWeight: "500",
//                                             display: 'inline-block'
//                                         }}>
//                                             {campaign.status || "DRAFT"}
//                                         </span>
//                                     </td>
//                                     <td style={tdStyle}>
//                                         <span style={{
//                                             padding: "4px 8px",
//                                             borderRadius: "4px",
//                                             backgroundColor: getApprovalStatusColor(campaign.approvalStatus || 'PENDING'),
//                                             color: "white",
//                                             fontSize: "12px",
//                                             fontWeight: "500",
//                                             display: 'inline-block'
//                                         }}>
//                                             {campaign.approvalStatus || 'PENDING'}
//                                         </span>
//                                     </td>
//                                     <td style={tdStyle}>
//                                         <span style={{
//                                             padding: "4px 8px",
//                                             borderRadius: "4px",
//                                             backgroundColor: getPaymentStatusColor(campaign.paymentStatus || 'PENDING'),
//                                             color: "white",
//                                             fontSize: "12px",
//                                             fontWeight: "500",
//                                             display: 'inline-block'
//                                         }}>
//                                             {campaign.paymentStatus || 'PENDING'}
//                                         </span>
//                                     </td>
//                                     <td style={tdStyle}>{formatDate(campaign.startDate)}</td>
//                                     <td style={tdStyle}>{formatDate(campaign.endDate)}</td>
//                                     <td style={tdStyle}>{campaign.city || campaign.targeting?.city || "-"}</td>
//                                     <td style={tdStyle}>{campaign.radiusKm || campaign.targeting?.radiusKm ? `${campaign.radiusKm || campaign.targeting?.radiusKm} km` : "-"}</td>
//                                     <td style={tdStyle}>{campaign.appType || "-"}</td>
//                                     <td style={tdStyle}>{campaign.mediaType || "-"}</td>
//                                     <td style={tdStyle}>{campaign.addDisplayPosition || "-"}</td>
//                                     <td style={tdStyle}>{campaign.resolution || "Auto-set"}</td>
//                                     <td style={tdStyle}>{campaign.customerId || "-"}</td>
//                                     <td style={tdStyle}>
//                                         {campaign.imageUrl ? (
//                                             <button
//                                                 onClick={() => openMediaPreview(campaign.imageUrl)}
//                                                 style={{
//                                                     backgroundColor: "#4CAF50",
//                                                     color: "white",
//                                                     border: "none",
//                                                     padding: "6px 12px",
//                                                     borderRadius: "4px",
//                                                     cursor: "pointer",
//                                                     fontSize: "12px",
//                                                     fontWeight: "500",
//                                                 }}
//                                                 onMouseOver={e => e.target.style.backgroundColor = '#45a049'}
//                                                 onMouseOut={e => e.target.style.backgroundColor = '#4CAF50'}
//                                             >
//                                                 View Creative
//                                             </button>
//                                         ) : (
//                                             "-"
//                                         )}
//                                     </td>
//                                     <td style={tdStyle}>
//                                         <div style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
//                                             {/* View Button */}
//                                             <button
//                                                 style={{
//                                                     backgroundColor: "#4CAF50",
//                                                     color: "white",
//                                                     border: "none",
//                                                     padding: "8px 12px",
//                                                     borderRadius: "4px",
//                                                     cursor: "pointer",
//                                                     fontSize: "12px",
//                                                     fontWeight: "500",
//                                                 }}
//                                                 onClick={() => handleViewCampaign(campaign)}
//                                                 onMouseOver={e => e.target.style.backgroundColor = '#45a049'}
//                                                 onMouseOut={e => e.target.style.backgroundColor = '#4CAF50'}
//                                             >
//                                                 View
//                                             </button>

//                                             {/* Edit Button */}
//                                             <button
//                                                 style={{
//                                                     backgroundColor: "#2196F3",
//                                                     color: "white",
//                                                     border: "none",
//                                                     padding: "8px 12px",
//                                                     borderRadius: "4px",
//                                                     cursor: "pointer",
//                                                     fontSize: "12px",
//                                                     fontWeight: "500",
//                                                 }}
//                                                 onClick={() => handleEditDirect(campaign)}
//                                                 onMouseOver={e => e.target.style.backgroundColor = '#1976d2'}
//                                                 onMouseOut={e => e.target.style.backgroundColor = '#2196F3'}
//                                             >
//                                                 Edit
//                                             </button>

//                                             {/* Delete Button */}
//                                             <button
//                                                 style={{
//                                                     backgroundColor: "#f44336",
//                                                     color: "white",
//                                                     border: "none",
//                                                     padding: "8px 12px",
//                                                     borderRadius: "4px",
//                                                     cursor: "pointer",
//                                                     fontSize: "12px",
//                                                     fontWeight: "500",
//                                                 }}
//                                                 onClick={() => handleDelete(campaign.id || campaign.campaignId)}
//                                                 onMouseOver={e => e.target.style.backgroundColor = '#d32f2f'}
//                                                 onMouseOut={e => e.target.style.backgroundColor = '#f44336'}
//                                             >
//                                                 Delete
//                                             </button>
//                                         </div>
//                                     </td>
//                                 </tr>
//                             ))
//                         )}
//                     </tbody>
//                 </table>
//             </div>

//             {/* Add Campaign Modal */}
//             {showAddModal && (
//                 <div style={modalOverlayStyle} onClick={(e) => {
//                     if (e.target === e.currentTarget) {
//                         setShowAddModal(false);
//                         resetForm();
//                     }
//                 }}>
//                     <div style={modalContentStyle} className="modal-enter">
//                         <div style={modalHeaderStyle}>
//                             <h3 style={{
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 fontWeight: 'bold',
//                                 margin: 0,
//                                 color: '#333'
//                             }}>
//                                 Create New Campaign
//                             </h3>
//                             <button
//                                 style={{
//                                     background: 'transparent',
//                                     border: 'none',
//                                     fontSize: '20px',
//                                     cursor: 'pointer',
//                                     color: '#666',
//                                     fontWeight: 'bold',
//                                     padding: '0',
//                                     width: '30px',
//                                     height: '30px',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     borderRadius: '4px',
//                                 }}
//                                 onClick={() => {
//                                     setShowAddModal(false);
//                                     resetForm();
//                                 }}
//                                 onMouseOver={e => e.target.style.backgroundColor = '#f0f0f0'}
//                                 onMouseOut={e => e.target.style.backgroundColor = 'transparent'}
//                             >
//                                 ✕
//                             </button>
//                         </div>

//                         <div style={modalBodyStyle}>
//                             <form onSubmit={handleAddCampaign}>
//                                 {/* Campaign Name */}
//                                 <div style={{ marginBottom: '20px' }}>
//                                     <label style={labelStyle}>Promotion Name *</label>
//                                     <input
//                                         type="text"
//                                         name="campaignName"
//                                         placeholder="Enter promotion name"
//                                         value={formData.campaignName}
//                                         onChange={handleChange}
//                                         required
//                                         style={inputStyle}
//                                     />
//                                 </div>

//                                 {/* Goal */}
//                                 <div style={{ marginBottom: '20px' }}>
//                                     <label style={labelStyle}>Goal *</label>
//                                     <select
//                                         name="goal"
//                                         value={formData.goal}
//                                         onChange={handleChange}
//                                         required
//                                         style={inputStyle}
//                                     >
//                                         {goalOptions.map((option) => (
//                                             <option key={option} value={option}>
//                                                 {option}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 <div style={{ marginBottom: '20px' }}>
//                                     <label style={labelStyle}>Sub Goal *</label>

//                                     <select
//                                         name="subGoal"
//                                         value={formData.subGoal}
//                                         onChange={handleChange}
//                                         required
//                                         style={inputStyle}
//                                     >
//                                         <option value="">Select Sub Goal</option>

//                                         {subGoalOptions.map((option) => (
//                                             <option key={option} value={option}>
//                                                 {option.replace(/_/g, " ")}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 {/* Medium */}
//                                 <div style={{ marginBottom: '20px' }}>
//                                     <label style={labelStyle}>Medium *</label>
//                                     <select
//                                         name="medium"
//                                         value={formData.medium}
//                                         onChange={handleChange}
//                                         required
//                                         style={inputStyle}
//                                     >
//                                         {mediumOptions.map((option) => (
//                                             <option key={option} value={option}>
//                                                 {option}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>
//                                 <div style={{ marginBottom: '20px' }}>
//                                     <label style={labelStyle}>Target Audience *</label>

//                                     {["Users", "Vendors", "Partners"].map((audience) => (
//                                         <label key={audience}>
//                                             <input
//                                                 type="checkbox"
//                                                 value={audience}
//                                                 checked={(formData.targetAudience || []).includes(audience)}
//                                                 onChange={(e) => {
//                                                     const { value, checked } = e.target;

//                                                     let updated = [...(formData.targetAudience || [])];

//                                                     if (checked) {
//                                                         updated.push(value);
//                                                     } else {
//                                                         updated = updated.filter(a => a !== value);
//                                                     }

//                                                     setFormData(prev => ({
//                                                         ...prev,
//                                                         targetAudience: updated,
//                                                         targeting: {
//                                                             ...prev.targeting,
//                                                             targetAudience: updated
//                                                         }
//                                                     }));
//                                                 }}
//                                             />
//                                             {audience}
//                                         </label>
//                                     ))}
//                                 </div>
//                                 {/* APP-Specific Fields */}
//                                 {formData.medium === "APP" && (
//                                     <>
//                                         {/* Start Date */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Start Date *</label>
//                                             <input
//                                                 type="date"
//                                                 name="startDate"
//                                                 value={formData.startDate}
//                                                 min={new Date().toISOString().split('T')[0]}
//                                                 onChange={handleChange}
//                                                 required
//                                                 style={inputStyle}
//                                             />
//                                         </div>

//                                         {/* End Date */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>End Date *</label>
//                                             <input
//                                                 type="date"
//                                                 name="endDate"
//                                                 value={formData.endDate}
//                                                 onChange={handleChange}
//                                                 min={formData.startDate || new Date().toISOString().split('T')[0]}
//                                                 required
//                                                 style={inputStyle}
//                                             />
//                                         </div>

//                                         {/* Interests (Checkboxes) */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Interests *</label>
//                                             <div style={{
//                                                 border: '1px solid #ddd',
//                                                 borderRadius: '6px',
//                                                 padding: '12px',
//                                                 maxHeight: '200px',
//                                                 overflowY: 'auto',
//                                                 backgroundColor: '#fff'
//                                             }}>
//                                                 {interestOptions.map((option) => (
//                                                     <label
//                                                         key={option}
//                                                         style={{
//                                                             display: 'flex',
//                                                             alignItems: 'center',
//                                                             marginBottom: '8px',
//                                                             cursor: 'pointer',
//                                                             padding: '4px',
//                                                             borderRadius: '4px',
//                                                             backgroundColor: formData.interests.includes(option) ? '#e3f2fd' : 'transparent',
//                                                         }}
//                                                     >
//                                                         <input
//                                                             type="checkbox"
//                                                             value={option}
//                                                             checked={formData.interests.includes(option)}
//                                                             onChange={(e) => {
//                                                                 const { value, checked } = e.target;
//                                                                 let updatedInterests = [...formData.interests];

//                                                                 if (checked) {
//                                                                     updatedInterests.push(value);
//                                                                 } else {
//                                                                     updatedInterests = updatedInterests.filter(interest => interest !== value);
//                                                                 }

//                                                                 if (updatedInterests.length === 0) {
//                                                                     alert("Please select at least one interest");
//                                                                     return;
//                                                                 }

//                                                                 setFormData(prev => ({
//                                                                     ...prev,
//                                                                     interests: updatedInterests,
//                                                                     targeting: {
//                                                                         ...prev.targeting,
//                                                                         interests: updatedInterests
//                                                                     }
//                                                                 }));
//                                                             }}
//                                                             style={{
//                                                                 marginRight: '10px',
//                                                                 cursor: 'pointer',
//                                                                 width: '16px',
//                                                                 height: '16px'
//                                                             }}
//                                                         />
//                                                         <span style={{
//                                                             fontSize: '14px',
//                                                             fontWeight: formData.interests.includes(option) ? '600' : '400'
//                                                         }}>
//                                                             {option}
//                                                         </span>
//                                                     </label>
//                                                 ))}
//                                             </div>
//                                             <small style={{ color: '#666', fontSize: '12px', display: 'block', marginTop: '8px' }}>
//                                                 Selected: {formData.interests.join(', ')}
//                                             </small>
//                                         </div>

//                                         {/* City with search */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>City</label>
//                                             <div style={{ display: 'flex', gap: '10px' }}>
//                                                 <input
//                                                     type="text"
//                                                     name="city"
//                                                     placeholder="Enter city name"
//                                                     value={formData.city}
//                                                     onChange={handleChange}
//                                                     style={{ ...inputStyle, flex: 1 }}
//                                                 />
//                                                 <button
//                                                     type="button"
//                                                     onClick={() => goToCity(formData.city)}
//                                                     style={{
//                                                         padding: '10px 20px',
//                                                         backgroundColor: '#4CAF50',
//                                                         color: 'white',
//                                                         border: 'none',
//                                                         borderRadius: '6px',
//                                                         cursor: 'pointer',
//                                                         fontWeight: '500',
//                                                         whiteSpace: 'nowrap'
//                                                     }}
//                                                 >
//                                                     Search
//                                                 </button>
//                                             </div>
//                                         </div>

//                                         {/* Location Map */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
//                                                 <label style={labelStyle}>Location</label>
//                                                 <button
//                                                     type="button"
//                                                     onClick={getCurrentLocation}
//                                                     style={{
//                                                         padding: '6px 12px',
//                                                         backgroundColor: '#2196F3',
//                                                         color: 'white',
//                                                         border: 'none',
//                                                         borderRadius: '4px',
//                                                         cursor: 'pointer',
//                                                         fontSize: '12px'
//                                                     }}
//                                                 >
//                                                     Get Current Location
//                                                 </button>
//                                             </div>
//                                             <div style={{ position: 'relative', height: '300px' }}>
//                                                 <div
//                                                     id="add-map"
//                                                     style={{
//                                                         width: '100%',
//                                                         height: '100%',
//                                                         borderRadius: '8px',
//                                                         border: '1px solid #ddd'
//                                                     }}
//                                                 ></div>
//                                                 {!locationLoaded && (
//                                                     <div style={{
//                                                         position: 'absolute',
//                                                         top: 0,
//                                                         left: 0,
//                                                         right: 0,
//                                                         bottom: 0,
//                                                         backgroundColor: 'rgba(0,0,0,0.3)',
//                                                         display: 'flex',
//                                                         alignItems: 'center',
//                                                         justifyContent: 'center',
//                                                         borderRadius: '8px'
//                                                     }}>
//                                                         <div style={{
//                                                             width: '40px',
//                                                             height: '40px',
//                                                             border: '3px solid #f3f3f3',
//                                                             borderTop: '3px solid #FF5722',
//                                                             borderRadius: '50%',
//                                                             animation: 'spin 1s linear infinite'
//                                                         }}></div>
//                                                     </div>
//                                                 )}
//                                             </div>
//                                             <input
//                                                 ref={searchInputRef}
//                                                 type="text"
//                                                 placeholder="Search for a location"
//                                                 style={{
//                                                     ...inputStyle,
//                                                     marginTop: '10px'
//                                                 }}
//                                             />
//                                         </div>

//                                         {/* Target Radius with Slider */}
//                                         <div style={{ marginBottom: '20px', backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '8px' }}>
//                                             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
//                                                 <label style={labelStyle}>Target Radius</label>
//                                                 <span style={{
//                                                     padding: '4px 12px',
//                                                     backgroundColor: '#FF5722',
//                                                     color: 'white',
//                                                     borderRadius: '20px',
//                                                     fontWeight: 'bold',
//                                                     fontSize: '14px'
//                                                 }}>
//                                                     {formData.radiusKm} km
//                                                 </span>
//                                             </div>
//                                             <input
//                                                 type="range"
//                                                 name="radiusKm"
//                                                 min="0"
//                                                 max="100"
//                                                 step="1"
//                                                 value={formData.radiusKm}
//                                                 onChange={handleChange}
//                                                 style={{ width: '100%', accentColor: '#FF5722' }}
//                                             />
//                                             <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px', color: '#666', fontSize: '12px' }}>
//                                                 <span>0 km</span>
//                                                 <span>25 km</span>
//                                                 <span>50 km</span>
//                                                 <span>100 km</span>
//                                             </div>
//                                         </div>

//                                         {/* Deep Link */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Deep Link</label>
//                                             <input
//                                                 type="url"
//                                                 name="deepLink"
//                                                 placeholder="https://example.com"
//                                                 value={formData.deepLink}
//                                                 onChange={handleChange}
//                                                 style={inputStyle}
//                                             />
//                                         </div>

//                                         {/* App Type */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>App Type *</label>
//                                             <select
//                                                 name="appType"
//                                                 value={formData.appType}
//                                                 onChange={handleChange}
//                                                 required
//                                                 style={inputStyle}
//                                             >
//                                                 {appTypeOptions.map((option) => (
//                                                     <option key={option} value={option}>
//                                                         {option.replace(/_/g, ' ')}
//                                                     </option>
//                                                 ))}
//                                             </select>
//                                         </div>

//                                         {/* Media Type */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Media Type *</label>
//                                             <select
//                                                 name="mediaType"
//                                                 value={formData.mediaType}
//                                                 onChange={handleChange}
//                                                 required
//                                                 style={inputStyle}
//                                             >
//                                                 {mediaTypeOptions.map((option) => (
//                                                     <option key={option} value={option}>
//                                                         {option}
//                                                     </option>
//                                                 ))}
//                                             </select>
//                                             <small style={{ color: '#666', fontSize: '12px', marginTop: '4px', display: 'block' }}>
//                                                 Select the type of media you're uploading
//                                             </small>
//                                         </div>

//                                         {/* Add Display Position */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Display Position *</label>
//                                             <select
//                                                 name="addDisplayPosition"
//                                                 value={formData.addDisplayPosition}
//                                                 onChange={handleChange}
//                                                 required
//                                                 style={inputStyle}
//                                             >
//                                                 {displayPositionOptions.map((option) => (
//                                                     <option key={option} value={option}>
//                                                         {option.replace(/_/g, ' ')}
//                                                     </option>
//                                                 ))}
//                                             </select>

//                                             {/* Display Position Info Table */}
//                                             {formData.addDisplayPosition && (
//                                                 <div style={{
//                                                     marginTop: '15px',
//                                                     padding: '15px',
//                                                     backgroundColor: '#f0f7ff',
//                                                     borderRadius: '8px',
//                                                     border: '1px solid #b8daff',
//                                                 }}>
//                                                     <h4 style={{
//                                                         margin: '0 0 10px 0',
//                                                         fontSize: '14px',
//                                                         color: '#004085',
//                                                         fontWeight: '600'
//                                                     }}>
//                                                         📊 Recommended Specifications for {formData.addDisplayPosition.replace(/_/g, ' ')}:
//                                                     </h4>
//                                                     <div style={{
//                                                         display: 'grid',
//                                                         gridTemplateColumns: '1fr 1fr',
//                                                         gap: '10px',
//                                                         fontSize: '13px'
//                                                     }}>
//                                                         <div><strong>Best Ratio:</strong> {displayPositionRatios[formData.addDisplayPosition]?.ratio}</div>
//                                                         <div><strong>Auto Resolution:</strong> {displayPositionRatios[formData.addDisplayPosition]?.resolution}</div>
//                                                         <div><strong>Description:</strong> {displayPositionRatios[formData.addDisplayPosition]?.description}</div>
//                                                         <div><strong>Media Type:</strong> {formData.mediaType}</div>
//                                                     </div>
//                                                     <p style={{
//                                                         margin: '10px 0 0 0',
//                                                         fontSize: '12px',
//                                                         color: '#28a745',
//                                                         fontStyle: 'italic'
//                                                     }}>
//                                                         ⚡ Resolution will be auto-set based on display position
//                                                     </p>
//                                                 </div>
//                                             )}
//                                         </div>

//                                         {/* Creative File */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Upload File *</label>
//                                             <input
//                                                 type="file"
//                                                 name="creative"
//                                                 onChange={handleCreativeChange}
//                                                 required
//                                                 style={{
//                                                     ...inputStyle,
//                                                     padding: '8px',
//                                                     cursor: 'pointer'
//                                                 }}
//                                                 accept=".jpg,.jpeg,.png,.gif,.mp4,.mov,.avi,.mkv,.webm"
//                                             />

//                                             {/* Creative Requirements Box */}
//                                             {formData.addDisplayPosition && (
//                                                 <div style={{
//                                                     marginTop: '15px',
//                                                     padding: '15px',
//                                                     backgroundColor: '#e3f2fd',
//                                                     borderLeft: '4px solid #2196f3',
//                                                     borderRadius: '4px',
//                                                     fontSize: '13px'
//                                                 }}>
//                                                     <strong style={{ color: '#1976d2', display: 'block', marginBottom: '10px', fontSize: '14px' }}>
//                                                         📋 Creative Requirements for {formData.addDisplayPosition.replace(/_/g, ' ')}:
//                                                     </strong>
//                                                     <div style={{
//                                                         display: 'grid',
//                                                         gridTemplateColumns: '1fr 1fr',
//                                                         gap: '10px'
//                                                     }}>
//                                                         <div>📁 <strong>Formats:</strong> {getCreativeRequirements(formData.addDisplayPosition).formats.join(', ')}</div>
//                                                         <div>📐 <strong>Dimensions:</strong> {getCreativeRequirements(formData.addDisplayPosition).dimensions}</div>
//                                                         <div>⚖️ <strong>Max Size:</strong> {getCreativeRequirements(formData.addDisplayPosition).maxSize}</div>
//                                                         <div>🖼️ <strong>Aspect Ratio:</strong> {getCreativeRequirements(formData.addDisplayPosition).aspectRatio}</div>
//                                                         <div>⏱️ <strong>Video Duration:</strong> {getCreativeRequirements(formData.addDisplayPosition).duration}</div>
//                                                         <div>🎯 <strong>Best Ratio:</strong> {getCreativeRequirements(formData.addDisplayPosition).bestRatio}</div>
//                                                     </div>
//                                                     <div style={{
//                                                         marginTop: '15px',
//                                                         padding: '10px',
//                                                         backgroundColor: '#c8e6c9',
//                                                         borderRadius: '4px',
//                                                         color: '#2e7d32',
//                                                         fontSize: '12px'
//                                                     }}>
//                                                         <strong>✨ Automatic Optimization:</strong> Your file will be automatically compressed by 30% to ensure optimal delivery and faster loading times.
//                                                     </div>
//                                                 </div>
//                                             )}

//                                             <small style={{ color: '#666', fontSize: '12px', marginTop: '8px', display: 'block' }}>
//                                                 * Please ensure your creative meets the requirements above. Files will be automatically compressed by 30% for optimal performance.
//                                             </small>
//                                         </div>

//                                         {/* Description */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Description</label>
//                                             <textarea
//                                                 name="description"
//                                                 placeholder="Enter campaign description"
//                                                 value={formData.description}
//                                                 onChange={handleChange}
//                                                 rows="3"
//                                                 style={{ ...inputStyle, resize: 'vertical' }}
//                                             />
//                                         </div>
//                                     </>
//                                 )}

//                                 {/* DIGITAL-Specific Fields */}
//                                 {formData.medium === "DIGITAL" && (
//                                     <>
//                                         {/* Start Date */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Start Date *</label>
//                                             <input
//                                                 type="date"
//                                                 name="startDate"
//                                                 value={formData.startDate}
//                                                 min={new Date().toISOString().split('T')[0]}
//                                                 onChange={handleChange}
//                                                 required
//                                                 style={inputStyle}
//                                             />
//                                         </div>

//                                         {/* End Date */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>End Date *</label>
//                                             <input
//                                                 type="date"
//                                                 name="endDate"
//                                                 value={formData.endDate}
//                                                 onChange={handleChange}
//                                                 min={formData.startDate || new Date().toISOString().split('T')[0]}
//                                                 required
//                                                 style={inputStyle}
//                                             />
//                                         </div>

//                                         {/* City */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>City</label>
//                                             <input
//                                                 type="text"
//                                                 name="city"
//                                                 placeholder="Enter city name"
//                                                 value={formData.city}
//                                                 onChange={handleChange}
//                                                 style={inputStyle}
//                                             />
//                                         </div>


//                                         {/* Media Type */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Media Type *</label>
//                                             <select
//                                                 name="mediaType"
//                                                 value={formData.mediaType}
//                                                 onChange={handleChange}
//                                                 required
//                                                 style={inputStyle}
//                                             >
//                                                 {mediaTypeOptions.map((option) => (
//                                                     <option key={option} value={option}>
//                                                         {option}
//                                                     </option>
//                                                 ))}
//                                             </select>
//                                         </div>

//                                         {/* Creative File */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Upload File *</label>
//                                             <input
//                                                 type="file"
//                                                 name="creative"
//                                                 onChange={handleCreativeChange}
//                                                 required
//                                                 style={{
//                                                     ...inputStyle,
//                                                     padding: '8px',
//                                                     cursor: 'pointer',
//                                                     borderColor: creativeFile ? (isCreativeValidForScreens() ? '#4CAF50' : '#f44336') : '#ddd'
//                                                 }}
//                                                 accept=".jpg,.jpeg,.png,.gif,.mp4,.mov,.avi,.mkv,.webm"
//                                             />

//                                             {/* Show creative validation status */}
//                                             {creativeFile && (
//                                                 <div style={{
//                                                     marginTop: '10px',
//                                                     padding: '10px',
//                                                     backgroundColor: isCreativeValidForScreens() ? '#e8f5e8' : '#ffebee',
//                                                     borderRadius: '4px',
//                                                     border: `1px solid ${isCreativeValidForScreens() ? '#4CAF50' : '#f44336'}`
//                                                 }}>
//                                                     <strong style={{ color: isCreativeValidForScreens() ? '#2e7d32' : '#c62828' }}>
//                                                         {isCreativeValidForScreens() ? '✓ Creative Valid' : '✗ Creative Validation Failed'}
//                                                     </strong>
//                                                     <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px', fontSize: '12px' }}>
//                                                         {creativeValidationMessages.map((msg, idx) => (
//                                                             <li key={idx} style={{ color: msg.valid ? '#2e7d32' : '#c62828' }}>
//                                                                 {msg.message}
//                                                             </li>
//                                                         ))}
//                                                     </ul>
//                                                 </div>
//                                             )}

//                                             {/* Creative Requirements Box */}
//                                             <div style={{
//                                                 marginTop: '15px',
//                                                 padding: '15px',
//                                                 backgroundColor: '#e3f2fd',
//                                                 borderLeft: '4px solid #2196f3',
//                                                 borderRadius: '4px',
//                                                 fontSize: '13px'
//                                             }}>
//                                                 <strong style={{ color: '#1976d2', display: 'block', marginBottom: '10px', fontSize: '14px' }}>
//                                                     📋 Creative Requirements for Digital Screens:
//                                                 </strong>
//                                                 <div style={{
//                                                     display: 'grid',
//                                                     gridTemplateColumns: '1fr 1fr',
//                                                     gap: '10px'
//                                                 }}>
//                                                     <div>📁 <strong>Formats:</strong> JPG, PNG, MP4</div>
//                                                     <div>📐 <strong>Dimensions:</strong> 1920x1080 pixels (16:9)</div>
//                                                     <div>⚖️ <strong>Max Size:</strong> 5 MB for images, 10 MB for videos</div>
//                                                     <div>⏱️ <strong>Video Duration:</strong> Maximum 20 seconds</div>
//                                                 </div>
//                                                 <div style={{
//                                                     marginTop: '15px',
//                                                     padding: '10px',
//                                                     backgroundColor: '#c8e6c9',
//                                                     borderRadius: '4px',
//                                                     color: '#2e7d32',
//                                                     fontSize: '12px'
//                                                 }}>
//                                                     <strong>✨ Automatic Optimization:</strong> Your file will be automatically compressed by 30% to ensure optimal delivery and faster loading times.
//                                                 </div>
//                                             </div>

//                                             <small style={{ color: '#666', fontSize: '12px', marginTop: '8px', display: 'block' }}>
//                                                 * Please ensure your creative meets the requirements above. Only screens with compatible resolution will be available for selection.
//                                             </small>
//                                         </div>

//                                         {/* Screen Selection with Checkboxes */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Select Screens *</label>

//                                             {loadingScreens ? (
//                                                 <div
//                                                     style={{
//                                                         display: "flex",
//                                                         justifyContent: "center",
//                                                         alignItems: "center",
//                                                         padding: "20px",
//                                                         gap: "10px",
//                                                     }}
//                                                 >
//                                                     <div
//                                                         style={{
//                                                             width: "20px",
//                                                             height: "20px",
//                                                             border: "2px solid #f3f3f3",
//                                                             borderTop: "2px solid rgb(230 109 51)",
//                                                             borderRadius: "50%",
//                                                             animation: "spin 1s linear infinite",
//                                                         }}
//                                                     ></div>
//                                                     <span>Loading screens...</span>
//                                                 </div>
//                                             ) : screens.length > 0 ? (
//                                                 <>
//                                                     <div
//                                                         style={{
//                                                             border: "1px solid #ddd",
//                                                             borderRadius: "6px",
//                                                             padding: "15px",
//                                                             maxHeight: "300px",
//                                                             overflowY: "auto",
//                                                             backgroundColor: "#fff",
//                                                         }}
//                                                     >
//                                                         {screens.map((screen) => {
//                                                             const screenId = screen.id || screen.screenId;
//                                                             const screenName =
//                                                                 screen.name || screen.screenName || `Screen ${screenId}`;
//                                                             const location = screen.location || screen.city || "Unknown location";
//                                                             const screenResolution =
//                                                                 screen.resolution || screen.aspectRatio || "16:9";

//                                                             return (
//                                                                 <label
//                                                                     key={screenId}
//                                                                     style={{
//                                                                         display: "flex",
//                                                                         alignItems: "flex-start",
//                                                                         marginBottom: "12px",
//                                                                         cursor: "pointer",
//                                                                         padding: "10px",
//                                                                         borderRadius: "4px",
//                                                                         backgroundColor: screenIds.includes(screenId)
//                                                                             ? "#e3f2fd"
//                                                                             : "transparent",
//                                                                         border: "1px solid #e0e0e0",
//                                                                     }}
//                                                                 >
//                                                                     <input
//                                                                         type="checkbox"
//                                                                         checked={screenIds.includes(screenId)}
//                                                                         onChange={() => handleScreenSelection(screenId)}
//                                                                         style={{
//                                                                             marginRight: "12px",
//                                                                             marginTop: "2px",
//                                                                             cursor: "pointer",
//                                                                             width: "16px",
//                                                                             height: "16px",
//                                                                         }}
//                                                                     />

//                                                                     <div style={{ flex: 1 }}>
//                                                                         <div
//                                                                             style={{
//                                                                                 fontSize: "14px",
//                                                                                 fontWeight: "600",
//                                                                                 marginBottom: "4px",
//                                                                             }}
//                                                                         >
//                                                                             {screenName}
//                                                                         </div>

//                                                                         <div
//                                                                             style={{
//                                                                                 fontSize: "12px",
//                                                                                 color: "#666",
//                                                                                 display: "flex",
//                                                                                 flexWrap: "wrap",
//                                                                                 gap: "8px",
//                                                                             }}
//                                                                         >
//                                                                             <span>ID: {screenId}</span>
//                                                                             <span>📍 {location}</span>
//                                                                             <span>📺 Resolution: {screenResolution}</span>
//                                                                         </div>
//                                                                     </div>
//                                                                 </label>
//                                                             );
//                                                         })}
//                                                     </div>

//                                                     <small
//                                                         style={{
//                                                             color: "#666",
//                                                             fontSize: "12px",
//                                                             marginTop: "8px",
//                                                             display: "block",
//                                                         }}
//                                                     >
//                                                         Selected screens: {screenIds.length}{" "}
//                                                         {screenIds.length === 1 ? "screen" : "screens"}
//                                                     </small>
//                                                 </>
//                                             ) : (
//                                                 <div
//                                                     style={{
//                                                         padding: "20px",
//                                                         textAlign: "center",
//                                                         backgroundColor: "#f5f5f5",
//                                                         borderRadius: "6px",
//                                                         border: "1px dashed #ccc",
//                                                     }}
//                                                 >
//                                                     <p style={{ color: "#666", marginBottom: "10px" }}>
//                                                         No screens available. Please add screens first.
//                                                     </p>
//                                                 </div>
//                                             )}
//                                         </div>

//                                         {/* Description */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Description</label>
//                                             <textarea
//                                                 name="description"
//                                                 placeholder="Enter campaign description"
//                                                 value={formData.description}
//                                                 onChange={handleChange}
//                                                 rows="3"
//                                                 style={{ ...inputStyle, resize: 'vertical' }}
//                                             />
//                                         </div>
//                                     </>
//                                 )}

//                                 {/* Form Buttons */}
//                                 <div style={{
//                                     display: 'flex',
//                                     gap: '10px',
//                                     marginTop: '20px',
//                                     position: 'sticky',
//                                     bottom: 0,
//                                     backgroundColor: '#fff',
//                                     padding: '10px 0',
//                                     borderTop: '1px solid #eee'
//                                 }}>
//                                     <button
//                                         type="submit"
//                                         style={{
//                                             padding: '12px',
//                                             backgroundColor: '#1976d2',
//                                             color: 'white',
//                                             fontWeight: '600',
//                                             border: 'none',
//                                             borderRadius: '6px',
//                                             cursor: 'pointer',
//                                             flex: 1,
//                                             fontSize: '14px',
//                                         }}
//                                         onMouseOver={e => e.target.style.backgroundColor = '#1565c0'}
//                                         onMouseOut={e => e.target.style.backgroundColor = '#1976d2'}
//                                     >
//                                         Create Campaign
//                                     </button>
//                                     <button
//                                         type="button"
//                                         style={{
//                                             padding: '12px',
//                                             backgroundColor: '#f5f5f5',
//                                             color: '#333',
//                                             fontWeight: '600',
//                                             border: '1px solid #ddd',
//                                             borderRadius: '6px',
//                                             cursor: 'pointer',
//                                             flex: 1,
//                                             fontSize: '14px',
//                                         }}
//                                         onClick={() => {
//                                             setShowAddModal(false);
//                                             resetForm();
//                                         }}
//                                         onMouseOver={e => e.target.style.backgroundColor = '#e0e0e0'}
//                                         onMouseOut={e => e.target.style.backgroundColor = '#f5f5f5'}
//                                     >
//                                         Cancel
//                                     </button>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Edit Campaign Modal */}
//             {showEditModal && selectedCampaign && (
//                 <div style={modalOverlayStyle} onClick={(e) => {
//                     if (e.target === e.currentTarget) {
//                         setShowEditModal(false);
//                         setSelectedCampaign(null);
//                         resetForm();
//                     }
//                 }}>
//                     <div style={modalContentStyle} className="modal-enter">
//                         <div style={modalHeaderStyle}>
//                             <h3 style={{
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 fontWeight: 'bold',
//                                 margin: 0,
//                                 color: '#333'
//                             }}>
//                                 Edit Campaign
//                             </h3>
//                             <button
//                                 style={{
//                                     background: 'transparent',
//                                     border: 'none',
//                                     fontSize: '20px',
//                                     cursor: 'pointer',
//                                     color: '#666',
//                                     fontWeight: 'bold',
//                                     padding: '0',
//                                     width: '30px',
//                                     height: '30px',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     borderRadius: '4px',
//                                 }}
//                                 onClick={() => {
//                                     setShowEditModal(false);
//                                     setSelectedCampaign(null);
//                                     resetForm();
//                                 }}
//                                 onMouseOver={e => e.target.style.backgroundColor = '#f0f0f0'}
//                                 onMouseOut={e => e.target.style.backgroundColor = 'transparent'}
//                             >
//                                 ✕
//                             </button>
//                         </div>

//                         <div style={modalBodyStyle}>
//                             <form onSubmit={handleEditCampaign}>
//                                 {/* Campaign Name */}
//                                 <div style={{ marginBottom: '20px' }}>
//                                     <label style={labelStyle}>Promotion Name *</label>
//                                     <input
//                                         type="text"
//                                         name="campaignName"
//                                         placeholder="Enter Promotion name"
//                                         value={formData.campaignName}
//                                         onChange={handleChange}
//                                         required
//                                         style={inputStyle}
//                                     />
//                                 </div>

//                                 {/* Customer ID Field */}
//                                 <div style={{ marginBottom: '20px' }}>
//                                     <label style={labelStyle}>Customer ID *</label>
//                                     <input
//                                         type="text"
//                                         name="customerId"
//                                         placeholder="Enter customer ID"
//                                         value={formData.customerId}
//                                         onChange={handleChange}
//                                         required
//                                         style={inputStyle}
//                                     />
//                                 </div>

//                                 {/* Description */}
//                                 <div style={{ marginBottom: '20px' }}>
//                                     <label style={labelStyle}>Description</label>
//                                     <textarea
//                                         name="description"
//                                         placeholder="Enter campaign description"
//                                         value={formData.description}
//                                         onChange={handleChange}
//                                         rows="3"
//                                         style={{ ...inputStyle, resize: 'vertical' }}
//                                     />
//                                 </div>

//                                 {/* Goal */}
//                                 <div style={{ marginBottom: '20px' }}>
//                                     <label style={labelStyle}>Goal *</label>
//                                     <select
//                                         name="goal"
//                                         value={formData.goal}
//                                         onChange={handleChange}
//                                         required
//                                         style={inputStyle}
//                                     >
//                                         {goalOptions.map((option) => (
//                                             <option key={option} value={option}>
//                                                 {option}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 {/* Medium */}
//                                 <div style={{ marginBottom: '20px' }}>
//                                     <label style={labelStyle}>Medium *</label>
//                                     <select
//                                         name="medium"
//                                         value={formData.medium}
//                                         onChange={handleChange}
//                                         required
//                                         style={inputStyle}
//                                     >
//                                         {mediumOptions.map((option) => (
//                                             <option key={option} value={option}>
//                                                 {option}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 {/* Payment Status */}
//                                 <div style={{ marginBottom: '20px' }}>
//                                     <label style={labelStyle}>Payment Status *</label>
//                                     <select
//                                         name="paymentStatus"
//                                         value={formData.paymentStatus}
//                                         onChange={handleChange}
//                                         required
//                                         style={inputStyle}
//                                     >
//                                         {paymentStatusOptions.map((option) => (
//                                             <option key={option} value={option}>
//                                                 {option}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 {/* APP-Specific Fields */}
//                                 {formData.medium === "APP" && (
//                                     <>
//                                         {/* Start Date */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Start Date *</label>
//                                             <input
//                                                 type="date"
//                                                 name="startDate"
//                                                 value={formData.startDate}
//                                                 min={new Date().toISOString().split('T')[0]}
//                                                 onChange={handleChange}
//                                                 required
//                                                 style={inputStyle}
//                                             />
//                                         </div>

//                                         {/* End Date */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>End Date *</label>
//                                             <input
//                                                 type="date"
//                                                 name="endDate"
//                                                 value={formData.endDate}
//                                                 onChange={handleChange}
//                                                 min={formData.startDate || new Date().toISOString().split('T')[0]}
//                                                 required
//                                                 style={inputStyle}
//                                             />
//                                         </div>

//                                         {/* Interests (Checkboxes) */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Interests *</label>
//                                             <div style={{
//                                                 border: '1px solid #ddd',
//                                                 borderRadius: '6px',
//                                                 padding: '12px',
//                                                 maxHeight: '200px',
//                                                 overflowY: 'auto',
//                                                 backgroundColor: '#fff'
//                                             }}>
//                                                 {interestOptions.map((option) => (
//                                                     <label
//                                                         key={option}
//                                                         style={{
//                                                             display: 'flex',
//                                                             alignItems: 'center',
//                                                             marginBottom: '8px',
//                                                             cursor: 'pointer',
//                                                             padding: '4px',
//                                                             borderRadius: '4px',
//                                                             backgroundColor: formData.interests.includes(option) ? '#e3f2fd' : 'transparent',
//                                                         }}
//                                                     >
//                                                         <input
//                                                             type="checkbox"
//                                                             value={option}
//                                                             checked={formData.interests.includes(option)}
//                                                             onChange={(e) => {
//                                                                 const { value, checked } = e.target;
//                                                                 let updatedInterests = [...formData.interests];

//                                                                 if (checked) {
//                                                                     updatedInterests.push(value);
//                                                                 } else {
//                                                                     updatedInterests = updatedInterests.filter(interest => interest !== value);
//                                                                 }

//                                                                 if (updatedInterests.length === 0) {
//                                                                     alert("Please select at least one interest");
//                                                                     return;
//                                                                 }

//                                                                 setFormData(prev => ({
//                                                                     ...prev,
//                                                                     interests: updatedInterests,
//                                                                     targeting: {
//                                                                         ...prev.targeting,
//                                                                         interests: updatedInterests
//                                                                     }
//                                                                 }));
//                                                             }}
//                                                             style={{
//                                                                 marginRight: '10px',
//                                                                 cursor: 'pointer',
//                                                                 width: '16px',
//                                                                 height: '16px'
//                                                             }}
//                                                         />
//                                                         <span style={{
//                                                             fontSize: '14px',
//                                                             fontWeight: formData.interests.includes(option) ? '600' : '400'
//                                                         }}>
//                                                             {option}
//                                                         </span>
//                                                     </label>
//                                                 ))}
//                                             </div>
//                                             <small style={{ color: '#666', fontSize: '12px', display: 'block', marginTop: '8px' }}>
//                                                 Selected: {formData.interests.join(', ')}
//                                             </small>
//                                         </div>

//                                         {/* City with search */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>City</label>
//                                             <div style={{ display: 'flex', gap: '10px' }}>
//                                                 <input
//                                                     type="text"
//                                                     name="city"
//                                                     placeholder="Enter city name"
//                                                     value={formData.city}
//                                                     onChange={handleChange}
//                                                     style={{ ...inputStyle, flex: 1 }}
//                                                 />
//                                                 <button
//                                                     type="button"
//                                                     onClick={() => goToCity(formData.city)}
//                                                     style={{
//                                                         padding: '10px 20px',
//                                                         backgroundColor: '#4CAF50',
//                                                         color: 'white',
//                                                         border: 'none',
//                                                         borderRadius: '6px',
//                                                         cursor: 'pointer',
//                                                         fontWeight: '500',
//                                                         whiteSpace: 'nowrap'
//                                                     }}
//                                                 >
//                                                     Search
//                                                 </button>
//                                             </div>
//                                         </div>

//                                         {/* Location Map */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
//                                                 <label style={labelStyle}>Location</label>
//                                                 <button
//                                                     type="button"
//                                                     onClick={getCurrentLocation}
//                                                     style={{
//                                                         padding: '6px 12px',
//                                                         backgroundColor: '#2196F3',
//                                                         color: 'white',
//                                                         border: 'none',
//                                                         borderRadius: '4px',
//                                                         cursor: 'pointer',
//                                                         fontSize: '12px'
//                                                     }}
//                                                 >
//                                                     Get Current Location
//                                                 </button>
//                                             </div>
//                                             <div style={{ position: 'relative', height: '300px' }}>
//                                                 <div
//                                                     id="edit-map"
//                                                     style={{
//                                                         width: '100%',
//                                                         height: '100%',
//                                                         borderRadius: '8px',
//                                                         border: '1px solid #ddd'
//                                                     }}
//                                                 ></div>
//                                                 {!locationLoaded && (
//                                                     <div style={{
//                                                         position: 'absolute',
//                                                         top: 0,
//                                                         left: 0,
//                                                         right: 0,
//                                                         bottom: 0,
//                                                         backgroundColor: 'rgba(0,0,0,0.3)',
//                                                         display: 'flex',
//                                                         alignItems: 'center',
//                                                         justifyContent: 'center',
//                                                         borderRadius: '8px'
//                                                     }}>
//                                                         <div style={{
//                                                             width: '40px',
//                                                             height: '40px',
//                                                             border: '3px solid #f3f3f3',
//                                                             borderTop: '3px solid #FF5722',
//                                                             borderRadius: '50%',
//                                                             animation: 'spin 1s linear infinite'
//                                                         }}></div>
//                                                     </div>
//                                                 )}
//                                             </div>
//                                             <input
//                                                 ref={searchInputRef}
//                                                 type="text"
//                                                 placeholder="Search for a location"
//                                                 style={{
//                                                     ...inputStyle,
//                                                     marginTop: '10px'
//                                                 }}
//                                             />
//                                         </div>

//                                         {/* Target Radius with Slider */}
//                                         <div style={{ marginBottom: '20px', backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '8px' }}>
//                                             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
//                                                 <label style={labelStyle}>Target Radius</label>
//                                                 <span style={{
//                                                     padding: '4px 12px',
//                                                     backgroundColor: '#FF5722',
//                                                     color: 'white',
//                                                     borderRadius: '20px',
//                                                     fontWeight: 'bold',
//                                                     fontSize: '14px'
//                                                 }}>
//                                                     {formData.radiusKm} km
//                                                 </span>
//                                             </div>
//                                             <input
//                                                 type="range"
//                                                 name="radiusKm"
//                                                 min="0"
//                                                 max="100"
//                                                 step="1"
//                                                 value={formData.radiusKm}
//                                                 onChange={handleChange}
//                                                 style={{ width: '100%', accentColor: '#FF5722' }}
//                                             />
//                                             <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px', color: '#666', fontSize: '12px' }}>
//                                                 <span>0 km</span>
//                                                 <span>25 km</span>
//                                                 <span>50 km</span>
//                                                 <span>100 km</span>
//                                             </div>
//                                         </div>

//                                         {/* Deep Link */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Deep Link</label>
//                                             <input
//                                                 type="url"
//                                                 name="deepLink"
//                                                 placeholder="https://example.com"
//                                                 value={formData.deepLink}
//                                                 onChange={handleChange}
//                                                 style={inputStyle}
//                                             />
//                                         </div>

//                                         {/* App Type */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>App Type *</label>
//                                             <select
//                                                 name="appType"
//                                                 value={formData.appType}
//                                                 onChange={handleChange}
//                                                 required
//                                                 style={inputStyle}
//                                             >
//                                                 {appTypeOptions.map((option) => (
//                                                     <option key={option} value={option}>
//                                                         {option.replace(/_/g, ' ')}
//                                                     </option>
//                                                 ))}
//                                             </select>
//                                         </div>

//                                         {/* Media Type */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Media Type *</label>
//                                             <select
//                                                 name="mediaType"
//                                                 value={formData.mediaType}
//                                                 onChange={handleChange}
//                                                 required
//                                                 style={inputStyle}
//                                             >
//                                                 {mediaTypeOptions.map((option) => (
//                                                     <option key={option} value={option}>
//                                                         {option}
//                                                     </option>
//                                                 ))}
//                                             </select>
//                                             <small style={{ color: '#666', fontSize: '12px', marginTop: '4px', display: 'block' }}>
//                                                 Select the type of media you're uploading
//                                             </small>
//                                         </div>

//                                         {/* Add Display Position */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Display Position *</label>
//                                             <select
//                                                 name="addDisplayPosition"
//                                                 value={formData.addDisplayPosition}
//                                                 onChange={handleChange}
//                                                 required
//                                                 style={inputStyle}
//                                             >
//                                                 {displayPositionOptions.map((option) => (
//                                                     <option key={option} value={option}>
//                                                         {option.replace(/_/g, ' ')}
//                                                     </option>
//                                                 ))}
//                                             </select>

//                                             {/* Display Position Info Table */}
//                                             {formData.addDisplayPosition && (
//                                                 <div style={{
//                                                     marginTop: '15px',
//                                                     padding: '15px',
//                                                     backgroundColor: '#f0f7ff',
//                                                     borderRadius: '8px',
//                                                     border: '1px solid #b8daff',
//                                                 }}>
//                                                     <h4 style={{
//                                                         margin: '0 0 10px 0',
//                                                         fontSize: '14px',
//                                                         color: '#004085',
//                                                         fontWeight: '600'
//                                                     }}>
//                                                         📊 Recommended Specifications for {formData.addDisplayPosition.replace(/_/g, ' ')}:
//                                                     </h4>
//                                                     <div style={{
//                                                         display: 'grid',
//                                                         gridTemplateColumns: '1fr 1fr',
//                                                         gap: '10px',
//                                                         fontSize: '13px'
//                                                     }}>
//                                                         <div><strong>Best Ratio:</strong> {displayPositionRatios[formData.addDisplayPosition]?.ratio}</div>
//                                                         <div><strong>Auto Resolution:</strong> {displayPositionRatios[formData.addDisplayPosition]?.resolution}</div>
//                                                         <div><strong>Description:</strong> {displayPositionRatios[formData.addDisplayPosition]?.description}</div>
//                                                         <div><strong>Media Type:</strong> {formData.mediaType}</div>
//                                                     </div>
//                                                     <p style={{
//                                                         margin: '10px 0 0 0',
//                                                         fontSize: '12px',
//                                                         color: '#28a745',
//                                                         fontStyle: 'italic'
//                                                     }}>
//                                                         ⚡ Resolution will be auto-set based on display position
//                                                     </p>
//                                                 </div>
//                                             )}
//                                         </div>
//                                     </>
//                                 )}

//                                 {/* DIGITAL-Specific Fields */}
//                                 {formData.medium === "DIGITAL" && (
//                                     <>
//                                         {/* Start Date */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Start Date *</label>
//                                             <input
//                                                 type="date"
//                                                 name="startDate"
//                                                 value={formData.startDate}
//                                                 min={new Date().toISOString().split('T')[0]}
//                                                 onChange={handleChange}
//                                                 required
//                                                 style={inputStyle}
//                                             />
//                                         </div>

//                                         {/* End Date */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>End Date *</label>
//                                             <input
//                                                 type="date"
//                                                 name="endDate"
//                                                 value={formData.endDate}
//                                                 onChange={handleChange}
//                                                 min={formData.startDate || new Date().toISOString().split('T')[0]}
//                                                 required
//                                                 style={inputStyle}
//                                             />
//                                         </div>

//                                         {/* City */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>City</label>
//                                             <input
//                                                 type="text"
//                                                 name="city"
//                                                 placeholder="Enter city name"
//                                                 value={formData.city}
//                                                 onChange={handleChange}
//                                                 style={inputStyle}
//                                             />
//                                         </div>

//                                         {/* Media Type */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Media Type *</label>
//                                             <select
//                                                 name="mediaType"
//                                                 value={formData.mediaType}
//                                                 onChange={handleChange}
//                                                 required
//                                                 style={inputStyle}
//                                             >
//                                                 {mediaTypeOptions.map((option) => (
//                                                     <option key={option} value={option}>
//                                                         {option}
//                                                     </option>
//                                                 ))}
//                                             </select>
//                                             <small style={{ color: '#666', fontSize: '12px', marginTop: '4px', display: 'block' }}>
//                                                 Select the type of media you're uploading
//                                             </small>
//                                         </div>

//                                         {/* Creative File - Before screen selection */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Creative File</label>
//                                             <input
//                                                 type="file"
//                                                 name="creative"
//                                                 onChange={handleCreativeChange}
//                                                 style={{
//                                                     ...inputStyle,
//                                                     padding: '8px',
//                                                     cursor: 'pointer',
//                                                     borderColor: creativeFile ? (isCreativeValidForScreens() ? '#4CAF50' : '#f44336') : '#ddd'
//                                                 }}
//                                                 accept=".jpg,.jpeg,.png,.gif,.mp4,.mov,.avi,.mkv,.webm"
//                                             />

//                                             {/* Show creative validation status */}
//                                             {creativeFile && (
//                                                 <div style={{
//                                                     marginTop: '10px',
//                                                     padding: '10px',
//                                                     backgroundColor: isCreativeValidForScreens() ? '#e8f5e8' : '#ffebee',
//                                                     borderRadius: '4px',
//                                                     border: `1px solid ${isCreativeValidForScreens() ? '#4CAF50' : '#f44336'}`
//                                                 }}>
//                                                     <strong style={{ color: isCreativeValidForScreens() ? '#2e7d32' : '#c62828' }}>
//                                                         {isCreativeValidForScreens() ? '✓ Creative Valid' : '✗ Creative Validation Failed'}
//                                                     </strong>
//                                                     <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px', fontSize: '12px' }}>
//                                                         {creativeValidationMessages.map((msg, idx) => (
//                                                             <li key={idx} style={{ color: msg.valid ? '#2e7d32' : '#c62828' }}>
//                                                                 {msg.message}
//                                                             </li>
//                                                         ))}
//                                                     </ul>
//                                                 </div>
//                                             )}

//                                             {/* Creative Requirements Box */}
//                                             <div style={{
//                                                 marginTop: '15px',
//                                                 padding: '15px',
//                                                 backgroundColor: '#fff3e0',
//                                                 borderLeft: '4px solid #ff9800',
//                                                 borderRadius: '4px',
//                                                 fontSize: '13px'
//                                             }}>
//                                                 <strong style={{ color: '#ed6c02', display: 'block', marginBottom: '10px', fontSize: '14px' }}>
//                                                     📋 Creative Requirements for Digital Screens:
//                                                 </strong>
//                                                 <div style={{
//                                                     display: 'grid',
//                                                     gridTemplateColumns: '1fr 1fr',
//                                                     gap: '10px'
//                                                 }}>
//                                                     <div>📁 <strong>Formats:</strong> JPG, PNG, MP4</div>
//                                                     <div>📐 <strong>Dimensions:</strong> 1920x1080 pixels (16:9)</div>
//                                                     <div>⚖️ <strong>Max Size:</strong> 5 MB for images, 10 MB for videos</div>
//                                                     <div>⏱️ <strong>Video Duration:</strong> Maximum 20 seconds</div>
//                                                 </div>
//                                                 <div style={{
//                                                     marginTop: '15px',
//                                                     padding: '10px',
//                                                     backgroundColor: '#c8e6c9',
//                                                     borderRadius: '4px',
//                                                     color: '#2e7d32',
//                                                     fontSize: '12px'
//                                                 }}>
//                                                     <strong>✨ Automatic Optimization:</strong> Your file will be automatically compressed by 30% to ensure optimal delivery and faster loading times.
//                                                 </div>
//                                             </div>

//                                             <small style={{ color: '#666', fontSize: '12px', marginTop: '8px', display: 'block' }}>
//                                                 * Leave empty to keep existing creative. New upload must meet requirements above. Only screens with compatible resolution will be available for selection.
//                                             </small>
//                                         </div>

//                                         {/* Screen Selection with Checkboxes */}
//                                         <div style={{ marginBottom: '20px' }}>
//                                             <label style={labelStyle}>Select Screens *</label>

//                                             {loadingScreens ? (
//                                                 <div style={{
//                                                     display: 'flex',
//                                                     justifyContent: 'center',
//                                                     alignItems: 'center',
//                                                     padding: '20px',
//                                                     gap: '10px'
//                                                 }}>
//                                                     <div style={{
//                                                         width: '20px',
//                                                         height: '20px',
//                                                         border: '2px solid #f3f3f3',
//                                                         borderTop: '2px solid rgb(230 109 51)',
//                                                         borderRadius: '50%',
//                                                         animation: 'spin 1s linear infinite'
//                                                     }}></div>
//                                                     <span>Loading screens...</span>
//                                                 </div>
//                                             ) : screens.length > 0 ? (
//                                                 <>
//                                                     {/* Filter screens based on creative compatibility */}
//                                                     {getCompatibleScreens().length === 0 && creativeFile ? (
//                                                         <div style={{
//                                                             padding: '20px',
//                                                             textAlign: 'center',
//                                                             backgroundColor: '#ffebee',
//                                                             borderRadius: '6px',
//                                                             border: '1px solid #f44336'
//                                                         }}>
//                                                             <p style={{ color: '#c62828', marginBottom: '10px', fontWeight: 'bold' }}>
//                                                                 No compatible screens found!
//                                                             </p>
//                                                             <p style={{ color: '#666', fontSize: '13px' }}>
//                                                                 Your creative's resolution ({getCreativeResolution()}) doesn't match any available screens.
//                                                                 Please upload a creative with 16:9 aspect ratio (1920x1080 pixels).
//                                                             </p>
//                                                         </div>
//                                                     ) : (
//                                                         <div style={{
//                                                             border: '1px solid #ddd',
//                                                             borderRadius: '6px',
//                                                             padding: '15px',
//                                                             maxHeight: '300px',
//                                                             overflowY: 'auto',
//                                                             backgroundColor: '#fff'
//                                                         }}>
//                                                             {/* Individual Screens */}
//                                                             {screens.map((screen) => {
//                                                                 const screenId = screen.id || screen.screenId;
//                                                                 const screenName = screen.name || screen.screenName || `Screen ${screenId}`;
//                                                                 const location = screen.location || screen.city || 'Unknown location';
//                                                                 const screenResolution = screen.resolution || screen.aspectRatio || '16:9';
//                                                                 const isCompatible = isScreenCompatible(screen);

//                                                                 return (
//                                                                     <label
//                                                                         key={screenId}
//                                                                         style={{
//                                                                             display: 'flex',
//                                                                             alignItems: 'flex-start',
//                                                                             marginBottom: '12px',
//                                                                             cursor: creativeFile && isCompatible ? 'pointer' : 'not-allowed',
//                                                                             padding: '10px',
//                                                                             borderRadius: '4px',
//                                                                             backgroundColor: screenIds.includes(screenId) ? '#e3f2fd' : 'transparent',
//                                                                             border: `1px solid ${isCompatible ? '#e0e0e0' : '#ffcdd2'}`,
//                                                                             opacity: creativeFile && isCompatible ? 1 : 0.5
//                                                                         }}
//                                                                     >
//                                                                         <input
//                                                                             type="checkbox"
//                                                                             checked={screenIds.includes(screenId)}
//                                                                             onChange={() => handleScreenSelection(screenId)}
//                                                                             disabled={!creativeFile || !isCompatible}
//                                                                             style={{
//                                                                                 marginRight: '12px',
//                                                                                 marginTop: '2px',
//                                                                                 cursor: creativeFile && isCompatible ? 'pointer' : 'not-allowed',
//                                                                                 width: '16px',
//                                                                                 height: '16px'
//                                                                             }}
//                                                                         />
//                                                                         <div style={{ flex: 1 }}>
//                                                                             <div style={{
//                                                                                 fontSize: '14px',
//                                                                                 fontWeight: '600',
//                                                                                 marginBottom: '4px',
//                                                                                 display: 'flex',
//                                                                                 justifyContent: 'space-between'
//                                                                             }}>
//                                                                                 <span>{screenName}</span>
//                                                                                 {!isCompatible && creativeFile && (
//                                                                                     <span style={{
//                                                                                         fontSize: '11px',
//                                                                                         color: '#f44336',
//                                                                                         backgroundColor: '#ffebee',
//                                                                                         padding: '2px 6px',
//                                                                                         borderRadius: '3px'
//                                                                                     }}>
//                                                                                         Incompatible resolution
//                                                                                     </span>
//                                                                                 )}
//                                                                             </div>
//                                                                             <div style={{
//                                                                                 fontSize: '12px',
//                                                                                 color: '#666',
//                                                                                 display: 'flex',
//                                                                                 flexWrap: 'wrap',
//                                                                                 gap: '8px'
//                                                                             }}>
//                                                                                 <span>ID: {screenId}</span>
//                                                                                 <span>📍 {location}</span>
//                                                                                 <span>📺 Resolution: {screenResolution}</span>
//                                                                                 {screen.resolution && (
//                                                                                     <span>📐 {screen.resolution}</span>
//                                                                                 )}
//                                                                             </div>
//                                                                         </div>
//                                                                     </label>
//                                                                 );
//                                                             })}
//                                                         </div>
//                                                     )}

//                                                     <small style={{ color: '#666', fontSize: '12px', marginTop: '8px', display: 'block' }}>
//                                                         Selected screens: {screenIds.length} {screenIds.length === 1 ? 'screen' : 'screens'}
//                                                         {!creativeFile && ' (Upload creative first to enable screen selection)'}
//                                                     </small>
//                                                 </>
//                                             ) : (
//                                                 <div style={{
//                                                     padding: '20px',
//                                                     textAlign: 'center',
//                                                     backgroundColor: '#f5f5f5',
//                                                     borderRadius: '6px',
//                                                     border: '1px dashed #ccc'
//                                                 }}>
//                                                     <p style={{ color: '#666', marginBottom: '10px' }}>
//                                                         No screens available. Please add screens first.
//                                                     </p>
//                                                 </div>
//                                             )}
//                                         </div>
//                                     </>
//                                 )}

//                                 {/* Status */}
//                                 <div style={{ marginBottom: '20px' }}>
//                                     <label style={labelStyle}>Status *</label>
//                                     <select
//                                         name="status"
//                                         value={formData.status}
//                                         onChange={handleChange}
//                                         required
//                                         style={inputStyle}
//                                     >
//                                         {statusOptions.map((option) => (
//                                             <option key={option} value={option}>
//                                                 {option}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 {/* Form Buttons */}
//                                 <div style={{
//                                     display: 'flex',
//                                     gap: '10px',
//                                     marginTop: '20px',
//                                     position: 'sticky',
//                                     bottom: 0,
//                                     backgroundColor: '#fff',
//                                     padding: '10px 0',
//                                     borderTop: '1px solid #eee'
//                                 }}>
//                                     <button
//                                         type="submit"
//                                         style={{
//                                             padding: '12px',
//                                             backgroundColor: '#2196F3',
//                                             color: 'white',
//                                             fontWeight: '600',
//                                             border: 'none',
//                                             borderRadius: '6px',
//                                             cursor: 'pointer',
//                                             flex: 1,
//                                             fontSize: '14px',
//                                         }}
//                                         onMouseOver={e => e.target.style.backgroundColor = '#1976d2'}
//                                         onMouseOut={e => e.target.style.backgroundColor = '#2196F3'}
//                                     >
//                                         Update Campaign
//                                     </button>
//                                     <button
//                                         type="button"
//                                         style={{
//                                             padding: '12px',
//                                             backgroundColor: '#f5f5f5',
//                                             color: '#333',
//                                             fontWeight: '600',
//                                             border: '1px solid #ddd',
//                                             borderRadius: '6px',
//                                             cursor: 'pointer',
//                                             flex: 1,
//                                             fontSize: '14px',
//                                         }}
//                                         onClick={() => {
//                                             setShowEditModal(false);
//                                             setSelectedCampaign(null);
//                                             resetForm();
//                                         }}
//                                         onMouseOver={e => e.target.style.backgroundColor = '#e0e0e0'}
//                                         onMouseOut={e => e.target.style.backgroundColor = '#f5f5f5'}
//                                     >
//                                         Cancel
//                                     </button>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// // Reusable styles
// const inputStyle = {
//     padding: '10px',
//     border: '1px solid #ddd',
//     borderRadius: '6px',
//     width: '100%',
//     boxSizing: 'border-box',
//     fontSize: '14px',
//     transition: 'border-color 0.3s',
//     backgroundColor: '#fff',
// };

// const labelStyle = {
//     fontSize: '14px',
//     marginBottom: '6px',
//     display: 'block',
//     fontWeight: '500',
//     color: '#333'
// };

// export default FoodSuperadminCampaign;





import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useLoader } from "../../../../context/LoaderProvider.jsx";
import {
    getAllCampaignsAPI,
    getAllScreensAPI,
    updateCampaignApprovalAPI,
    deleteCampaignAPI,
    getCampaignByIdAPI,
    createCampaignAPI,
} from "../../../../Component/Servicefile/campaignService";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Add: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
    ),
    Edit: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
    ),
    Delete: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
        </svg>
    ),
    View: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6" />
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
        </svg>
    ),
    Close: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Campaign: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z" />
            <path d="M2 17l10 5 10-5" />
            <path d="M2 12l10 5 10-5" />
        </svg>
    ),
    Image: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="2" width="20" height="20" rx="2" />
            <circle cx="8.5" cy="8.5" r="2.5" />
            <path d="M21 15l-5-5L5 21" />
        </svg>
    ),
    Location: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
            <circle cx="12" cy="10" r="3" />
        </svg>
    ),
    Calendar: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
    ),
    Money: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0b5e42" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    ),
    Status: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
            <path d="M8 7h8M8 11h6M8 15h4" />
        </svg>
    ),
    Approve: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#276749" strokeWidth="3">
            <polyline points="20 6 9 17 4 12" />
        </svg>
    ),
    Reject: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9b2c2c" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',
        // background: '#f8f9fa',
        borderRadius: '16px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        minHeight: '500px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    statsContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
        gap: '12px',
        marginBottom: '16px',
        padding: '16px',
        background: 'white',
        borderRadius: '12px',
        border: '1px solid #edf2f7'
    },
    statItem: {
        textAlign: 'center'
    },
    statValue: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#2d3748'
    },
    statLabel: {
        fontSize: '12px',
        color: '#718096',
        fontWeight: '500',
        textTransform: 'uppercase',
        letterSpacing: '0.3px'
    },
    tableWrapper: {
        borderRadius: '12px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '550px',
        width: '80vw',
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '1600px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '10px 12px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 12px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px',
        textAlign: 'center',
        verticalAlign: 'middle'
    },
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '600',
        letterSpacing: '0.3px'
    },
    badgeApproved: {
        background: '#c6f6d5',
        color: '#276749'
    },
    badgePending: {
        background: '#fefcbf',
        color: '#975a16'
    },
    badgeRejected: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    badgeDefault: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    button: {
        padding: '6px 14px',
        borderRadius: '6px',
        border: 'none',
        fontWeight: '600',
        fontSize: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        height: '32px',
        whiteSpace: 'nowrap'
    },
    buttonPrimary: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        boxShadow: '0 2px 10px rgba(230, 109, 51, 0.2)'
    },
    buttonSuccess: {
        background: '#48bb78',
        color: 'white'
    },
    buttonDanger: {
        background: '#fc8181',
        color: 'white'
    },
    buttonInfo: {
        background: '#63b3ed',
        color: 'white'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        backdropFilter: 'blur(4px)',
        padding: '20px'
    },
    modal: {
        background: 'white',
        borderRadius: '16px',
        padding: '28px',
        width: '580px',
        maxWidth: '95%',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        animation: 'slideUp 0.3s ease'
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: '16px',
        borderBottom: '2px solid #f0f0f0',
        marginBottom: '20px',
        position: 'sticky',
        top: 0,
        background: 'white',
        zIndex: 5
    },
    modalTitle: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#1a1a2e',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    modalClose: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#a0aec0',
        transition: 'all 0.3s ease',
        padding: '4px'
    },
    modalBody: {
        padding: '0 0 4px 0'
    },
    formGroup: {
        marginBottom: '16px'
    },
    label: {
        display: 'block',
        marginBottom: '6px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#4a5568'
    },
    input: {
        width: '100%',
        padding: '10px 14px',
        borderRadius: '8px',
        border: '2px solid #e2e8f0',
        fontSize: '13px',
        outline: 'none',
        transition: 'all 0.3s ease',
        boxSizing: 'border-box',
        background: 'white'
    },
    textarea: {
        width: '100%',
        padding: '10px 14px',
        borderRadius: '8px',
        border: '2px solid #e2e8f0',
        fontSize: '13px',
        outline: 'none',
        transition: 'all 0.3s ease',
        resize: 'vertical',
        boxSizing: 'border-box',
        fontFamily: 'inherit'
    },
    select: {
        width: '100%',
        padding: '10px 14px',
        borderRadius: '8px',
        border: '2px solid #e2e8f0',
        fontSize: '13px',
        outline: 'none',
        transition: 'all 0.3s ease',
        boxSizing: 'border-box',
        background: 'white',
        cursor: 'pointer'
    },
    modalFooter: {
        display: 'flex',
        gap: '10px',
        paddingTop: '16px',
        borderTop: '2px solid #f0f0f0',
        marginTop: '4px',
        position: 'sticky',
        bottom: 0,
        background: 'white',
        zIndex: 5
    },
    actionGroup: {
        display: 'flex',
        gap: '6px',
        justifyContent: 'center',
        // flexWrap: 'wrap'
    },
    creativePreview: {
        width: '60px',
        height: '60px',
        objectFit: 'cover',
        borderRadius: '8px',
        border: '2px solid #e2e8f0',
        cursor: 'pointer',
        transition: 'all 0.3s ease'
    },
    creativePreviewHover: {
        transform: 'scale(1.05)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
    },
    searchWrapper: {
        position: 'relative',
        flex: '1 1 200px',
        minWidth: '180px'
    },
    searchInput: {
        width: '100%',
        padding: '8px 14px 8px 36px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '13px',
        outline: 'none',
        transition: 'all 0.3s ease',
        height: '40px',
        background: 'white'
    },
    filterGroup: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px'
    }
};

const FoodSuperadminCampaign = () => {
    const [campaigns, setCampaigns] = useState([]);
    const [formData, setFormData] = useState({
        campaignName: "",
        description: "",
        interests: ["JOBS"],
        goal: "BRANDING",
        medium: "APP",
        status: "ACTIVE",
        startDate: "",
        subGoal: "",
        endDate: "",
        city: "",
        radiusKm: 100,
        centerLatitude: 17.3850,
        centerLongitude: 78.4867,
        deepLink: "",
        appType: "FOOD_AND_BEVERAGES",
        mediaType: "IMAGE",
        addDisplayPosition: "ADD_SCREEN",
        customerId: "ADM161220251",
        paymentStatus: "PENDING",
        loops: 7,
        period: "PER_DAY",
        targetAudience: ["Users"],
        targeting: {
            interests: ["JOBS"],
            city: "",
            centerLatitude: 17.3850,
            centerLongitude: 78.4867,
            radiusKm: 100,
            targetAudience: ["Users"],
        }
    });
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedCampaign, setSelectedCampaign] = useState(null);
    const [viewCampaign, setViewCampaign] = useState(null);
    const [creativeFile, setCreativeFile] = useState(null);
    const { showLoader, hideLoader } = useLoader();
    const [loading, setLoading] = useState(true);
    const [locationLoaded, setLocationLoaded] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    // Digital-specific states
    const [screenIds, setScreenIds] = useState([]);
    const [screens, setScreens] = useState([]);
    const [loadingScreens, setLoadingScreens] = useState(false);
    const [creativeResolution, setCreativeResolution] = useState(null);
    const [creativeDuration, setCreativeDuration] = useState(null);
    const [creativeValidationMessages, setCreativeValidationMessages] = useState([]);

    // State for rejection input inside view modal
    const [showRejectionInput, setShowRejectionInput] = useState(false);
    const [rejectionReason, setRejectionReason] = useState('');

    // State for approval modal
    const [showApprovalModal, setShowApprovalModal] = useState(false);
    const [selectedCampaignForApproval, setSelectedCampaignForApproval] = useState(null);
    const [approvalData, setApprovalData] = useState({
        campaignId: null,
        approvalStatus: "PENDING",
        rejectionReason: ""
    });

    // State for media preview
    const [showMediaPreview, setShowMediaPreview] = useState(false);
    const [previewMediaUrl, setPreviewMediaUrl] = useState('');
    const [previewMediaType, setPreviewMediaType] = useState('');

    // Search state
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredCampaigns, setFilteredCampaigns] = useState([]);

    // Refs
    const mapRef = useRef(null);
    const mapInstanceRef = useRef(null);
    const markerRef = useRef(null);
    const circleRef = useRef(null);
    const searchInputRef = useRef(null);

    // Interest options
    const interestOptions = [
        "JOBS", "FOOD", "EDUCATION", "OFFERS", "REAL_ESTATE",
        "ONLINE_COURSES", "BAKERY", "HEALTH", "TRAVEL", "ENTERTAINMENT"
    ];

    const goalOptions = ["BRANDING", "DISCOUNT", "LEADS", "EVENTS", "SPONSORSHIP"];
    const subGoalOptionsMap = {
        BRANDING: ["BRAND_AWARENESS", "BRAND_RECALL", "PREMIUM_POSTING"],
        LEADS: ["GET_MORE_MESSAGES", "GET_MORE_CALLS", "GET_MORE_WHATSAPP_MESSAGE", "GET_MORE_PAGE_LIKES", "GET_MORE_LEADS", "GET_MORE_WEBSITE_VISITORS"]
    };
    const subGoalOptions = subGoalOptionsMap[formData.goal] || [];
    const mediumOptions = ["APP", "DIGITAL", "PHYSICAL"];
    const statusOptions = ["DRAFT", "SCHEDULED", "ACTIVE", "PAUSED", "COMPLETED", "CANCELLED"];
    const approvalStatusOptions = ["PENDING", "APPROVED", "REJECTED"];
    const paymentStatusOptions = ["PENDING", "PAID", "FAILED", "REFUNDED", "CANCELLED"];
    const appTypeOptions = ["FOOD_AND_BEVERAGES", "RETAIL", "SERVICES", "ENTERTAINMENT", "EDUCATION", "HEALTHCARE"];
    const displayPositionOptions = ["ADD_SCREEN", "HOMEPAGE_BANNER", "PRODUCT_PAGE", "CHECKOUT_PAGE", "IN_APP_POPUP"];
    const mediaTypeOptions = ["IMAGE", "VIDEO"];

    const displayPositionRatios = {
        "ADD_SCREEN": { ratio: "9:16", resolution: "R_720P", description: "Full-screen vertical ad" },
        "HOMEPAGE_BANNER": { ratio: "16:9", resolution: "R_4K", description: "Wide banner style" },
        "PRODUCT_PAGE": { ratio: "4:5", resolution: "R_1080P", description: "Product-focused layout" },
        "CHECKOUT_PAGE": { ratio: "4:5", resolution: "R_1080P", description: "Compact promotional block" },
        "IN_APP_POPUP": { ratio: "9:16", resolution: "R_720P", description: "Overlay popup style" }
    };

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Fetch all campaigns
    useEffect(() => {
        const fetchCampaigns = async () => {
            try {
                showLoader();
                setLoading(true);
                const result = await getAllCampaignsAPI();
                const campaignsArray = Array.isArray(result) ? result : [result];
                setCampaigns(campaignsArray);
                setFilteredCampaigns(campaignsArray);
            } catch (error) {
                console.error("❌ Error fetching campaigns:", error);
                alert("Failed to fetch campaigns");
            } finally {
                setLoading(false);
                hideLoader();
            }
        };
        fetchCampaigns();
    }, []);

    // Filter campaigns based on search
    useEffect(() => {
        if (!searchTerm.trim()) {
            setFilteredCampaigns(campaigns);
            return;
        }
        const term = searchTerm.toLowerCase().trim();
        const filtered = campaigns.filter(campaign =>
            campaign.campaignName?.toLowerCase().includes(term) ||
            campaign.description?.toLowerCase().includes(term) ||
            campaign.campaignId?.toString().includes(term) ||
            campaign.id?.toString().includes(term)
        );
        setFilteredCampaigns(filtered);
    }, [searchTerm, campaigns]);

    const getStatusColor = (status) => {
        const colors = {
            'DRAFT': '#9E9E9E',
            'SCHEDULED': '#FF9800',
            'ACTIVE': '#4CAF50',
            'PAUSED': '#FFC107',
            'COMPLETED': '#2196F3',
            'CANCELLED': '#f44336'
        };
        return colors[status] || '#9E9E9E';
    };

    const getApprovalStatusColor = (status) => {
        const colors = {
            'PENDING': '#FF9800',
            'APPROVED': '#4CAF50',
            'REJECTED': '#f44336'
        };
        return colors[status] || '#9E9E9E';
    };

    const getPaymentStatusColor = (status) => {
        const colors = {
            'PENDING': '#FF9800',
            'PAID': '#4CAF50',
            'FAILED': '#f44336',
            'REFUNDED': '#9C27B0',
            'CANCELLED': '#9E9E9E'
        };
        return colors[status] || '#9E9E9E';
    };

    const getApprovalBadge = (status) => {
        if (status === 'APPROVED') return styles.badgeApproved;
        if (status === 'REJECTED') return styles.badgeRejected;
        return styles.badgePending;
    };

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB", {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toLocaleString("en-GB", {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const openMediaPreview = (url) => {
        if (!url) return;
        const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv'];
        const extension = url.split('.').pop()?.toLowerCase().split('?')[0];
        const isVideo = videoExtensions.includes(extension) || url.includes('video') || url.includes('mp4');
        setPreviewMediaUrl(url);
        setPreviewMediaType(isVideo ? 'video' : 'image');
        setShowMediaPreview(true);
    };

    const closeMediaPreview = () => {
        setShowMediaPreview(false);
        setPreviewMediaUrl('');
        setPreviewMediaType('');
    };

    // Handle view campaign
    const handleViewCampaign = async (campaign) => {
        const campaignId = campaign.id || campaign.campaignId;
        try {
            showLoader();
            const data = await getCampaignByIdAPI(campaignId);
            setViewCampaign(data || campaign);
        } catch (error) {
            console.error("Error fetching campaign:", error);
            setViewCampaign(campaign);
        } finally {
            hideLoader();
        }
        setShowRejectionInput(false);
        setRejectionReason('');
        setShowViewModal(true);
    };

    // Handle delete campaign
    const handleDelete = async (campaignId) => {
        if (!window.confirm("Are you sure you want to delete this campaign?")) return;
        try {
            showLoader();
            await deleteCampaignAPI(campaignId);
            setCampaigns(prev => prev.filter(c => c.id !== campaignId && c.campaignId !== campaignId));
            setFilteredCampaigns(prev => prev.filter(c => c.id !== campaignId && c.campaignId !== campaignId));
            alert("Campaign deleted successfully!");
        } catch (error) {
            console.error("Error deleting campaign:", error);
            alert("Failed to delete campaign");
        } finally {
            hideLoader();
        }
    };

    // Handle approve campaign
    const handleDirectApprove = async (campaign) => {
        if (!window.confirm(`Are you sure you want to approve campaign "${campaign.campaignName}"?`)) return;
        try {
            showLoader();
            const campaignId = campaign.id || campaign.campaignId;
            await updateCampaignApprovalAPI({ campaignId, approvalStatus: "APPROVED", rejectionReason: "" });
            updateCampaignInList(campaignId, "APPROVED");
            alert("Campaign approved successfully!");
        } catch (error) {
            console.error("Error approving campaign:", error);
            alert("Failed to approve campaign");
        } finally {
            hideLoader();
        }
    };

    // Handle reject campaign
    const handleDirectReject = async (campaign) => {
        if (!rejectionReason.trim()) {
            alert("Please provide a rejection reason");
            return;
        }
        try {
            showLoader();
            const campaignId = campaign.id || campaign.campaignId;
            await updateCampaignApprovalAPI({ campaignId, approvalStatus: "REJECTED", rejectionReason: rejectionReason.trim() });
            updateCampaignInList(campaignId, "REJECTED");
            alert("Campaign rejected successfully!");
            setShowRejectionInput(false);
            setRejectionReason("");
        } catch (error) {
            console.error("Error rejecting campaign:", error);
            alert("Failed to reject campaign");
        } finally {
            hideLoader();
        }
    };

    const updateCampaignInList = (campaignId, status) => {
        setCampaigns(prev => prev.map(c =>
            (c.id === campaignId || c.campaignId === campaignId) ? { ...c, approvalStatus: status } : c
        ));
        setFilteredCampaigns(prev => prev.map(c =>
            (c.id === campaignId || c.campaignId === campaignId) ? { ...c, approvalStatus: status } : c
        ));
        if (viewCampaign && (viewCampaign.id === campaignId || viewCampaign.campaignId === campaignId)) {
            setViewCampaign(prev => ({ ...prev, approvalStatus: status }));
        }
    };

    // Calculate stats
    const totalCampaigns = campaigns.length;
    const approvedCount = campaigns.filter(c => c.approvalStatus === 'APPROVED').length;
    const pendingCount = campaigns.filter(c => c.approvalStatus === 'PENDING').length;
    const rejectedCount = campaigns.filter(c => c.approvalStatus === 'REJECTED').length;
    const activeCount = campaigns.filter(c => c.status === 'ACTIVE').length;

    return (
        <div style={styles.container}>
            {/* Media Preview Modal */}
            {showMediaPreview && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.9)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10000,
                    padding: '20px'
                }} onClick={closeMediaPreview}>
                    <div style={{ position: 'relative', maxWidth: '90%', maxHeight: '90%' }} onClick={e => e.stopPropagation()}>
                        <button
                            style={{
                                position: 'absolute',
                                top: '-40px',
                                right: '-40px',
                                background: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '40px',
                                height: '40px',
                                fontSize: '20px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                zIndex: 10001
                            }}
                            onClick={closeMediaPreview}
                        >
                            ✕
                        </button>
                        {previewMediaType === 'video' ? (
                            <video controls autoPlay style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: '8px' }}>
                                <source src={previewMediaUrl} type="video/mp4" />
                                <source src={previewMediaUrl} type="video/webm" />
                                <source src={previewMediaUrl} type="video/ogg" />
                            </video>
                        ) : (
                            <img src={previewMediaUrl} alt="Preview" style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: '8px' }} />
                        )}
                    </div>
                </div>
            )}


            {/* Search Filter */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "16px",
                    flexWrap: "wrap",
                    marginBottom: "16px",
                }}
            >
                {/* Left Side - Search */}
                <div style={{ flex: 1, minWidth: "280px", maxWidth: "400px" }}>
                    <div style={styles.searchWrapper}>
                        

                        <input
                            type="text"
                            placeholder="Search campaigns..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                ...styles.searchInput,
                                borderColor: searchTerm ? "#e66d33" : "#e2e8f0",
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = "#e66d33";
                                e.target.style.boxShadow = "0 0 0 3px rgba(230,109,51,0.1)";
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = "#e2e8f0";
                                e.target.style.boxShadow = "none";
                            }}
                        />
                    </div>
                </div>

                {/* Right Side - Buttons */}
                <div
                    style={{
                        display: "flex",
                        gap: "12px",
                        flexWrap: "wrap",
                    }}
                >
                    <button
                        onClick={() => window.location.reload()}
                        style={{ ...styles.button, ...styles.buttonPrimary }}
                    >
                        <Icons.Refresh /> Refresh
                    </button>

                    <button
                        onClick={() => {
                            setFormData({
                                campaignName: "",
                                description: "",
                                interests: ["JOBS"],
                                goal: "BRANDING",
                                medium: "APP",
                                status: "ACTIVE",
                                startDate: "",
                                subGoal: "",
                                endDate: "",
                                city: "",
                                radiusKm: 100,
                                centerLatitude: 17.3850,
                                centerLongitude: 78.4867,
                                deepLink: "",
                                appType: "FOOD_AND_BEVERAGES",
                                mediaType: "IMAGE",
                                addDisplayPosition: "ADD_SCREEN",
                                customerId: "ADM161220251",
                                paymentStatus: "PENDING",
                                loops: 7,
                                period: "PER_DAY",
                                targetAudience: ["Users"],
                                targeting: {
                                    interests: ["JOBS"],
                                    city: "",
                                    centerLatitude: 17.3850,
                                    centerLongitude: 78.4867,
                                    radiusKm: 100,
                                    targetAudience: ["Users"],
                                },
                            });

                            setCreativeFile(null);
                            setScreenIds([]);
                            setShowAddModal(true);
                        }}
                        style={{ ...styles.button, ...styles.buttonSuccess }}
                    >
                        <Icons.Add /> Create Campaign
                    </button>
                </div>
            </div>

            {/* Table */}
            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead style={styles.thead}>
                        <tr>
                            <th style={{ ...styles.th, width: '3%' }}>#</th>
                            <th style={{ ...styles.th, width: '10%' }}>Campaign Name</th>
                            <th style={{ ...styles.th, width: '10%' }}>Description</th>
                            <th style={{ ...styles.th, width: '8%' }}>Interests</th>
                            <th style={{ ...styles.th, width: '6%' }}>Goal</th>
                            <th style={{ ...styles.th, width: '6%' }}>Medium</th>
                            <th style={{ ...styles.th, width: '7%', textAlign: 'center' }}>Status</th>
                            <th style={{ ...styles.th, width: '7%', textAlign: 'center' }}>Approval</th>
                            <th style={{ ...styles.th, width: '7%', textAlign: 'center' }}>Payment</th>
                            <th style={{ ...styles.th, width: '7%' }}>Start Date</th>
                            <th style={{ ...styles.th, width: '7%' }}>End Date</th>
                            <th style={{ ...styles.th, width: '6%' }}>City</th>
                            <th style={{ ...styles.th, width: '5%' }}>Radius</th>
                            <th style={{ ...styles.th, width: '6%' }}>App Type</th>
                            <th style={{ ...styles.th, width: '6%' }}>Media</th>
                            <th style={{ ...styles.th, width: '8%' }}>Display</th>
                            <th style={{ ...styles.th, width: '7%' }}>Creative</th>
                            <th style={{ ...styles.th, width: '10%', textAlign: 'center' }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="18" style={{ padding: 0 }}>
                                    <div style={{ textAlign: 'center', padding: '40px' }}>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p style={{ marginTop: '16px', color: '#718096' }}>Loading campaigns...</p>
                                    </div>
                                </td>
                            </tr>
                        ) : filteredCampaigns.length === 0 ? (
                            <tr>
                                <td colSpan="18" style={{ padding: 0 }}>
                                    <div style={styles.emptyState}>
                                        <Icons.NoData />
                                        <div style={styles.emptyStateText}>No campaigns found</div>
                                        <div style={styles.emptyStateSubtext}>
                                            {searchTerm ? 'Try adjusting your search terms' : 'Create your first campaign to get started'}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            filteredCampaigns.map((campaign, index) => (
                                <tr
                                    key={campaign.id || campaign.campaignId || index}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                        transition: 'background 0.15s ease'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                >
                                    <td style={{ ...styles.td, color: '#a0aec0' }}>{index + 1}</td>
                                    <td style={{ ...styles.td, fontWeight: '500' }}>{campaign.campaignName || "-"}</td>
                                    <td style={{ ...styles.td }}>{campaign.description || "-"}</td>
                                    <td style={styles.td}>
                                        <span style={{
                                            fontSize: '10px',
                                            background: '#edf2f7',
                                            padding: '2px 8px',
                                            borderRadius: '4px',
                                            color: '#4a5568',
                                            display: 'inline-block'
                                        }}>
                                            {campaign.interests && campaign.interests.length > 0
                                                ? campaign.interests.join(', ')
                                                : campaign.targeting?.interests?.join(', ') || "-"}
                                        </span>
                                    </td>
                                    <td style={{ ...styles.td, fontSize: '12px' }}>{campaign.goal || "-"}</td>
                                    <td style={{ ...styles.td, fontSize: '12px' }}>
                                        <span style={{
                                            background: campaign.medium === 'DIGITAL' ? '#bee3f8' :
                                                campaign.medium === 'APP' ? '#c6f6d5' : '#fefcbf',
                                            padding: '2px 10px',
                                            borderRadius: '4px',
                                            fontSize: '11px',
                                            fontWeight: '600',
                                            color: campaign.medium === 'DIGITAL' ? '#2a4365' :
                                                campaign.medium === 'APP' ? '#276749' : '#975a16'
                                        }}>
                                            {campaign.medium || "-"}
                                        </span>
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        <span style={{
                                            ...styles.badge,
                                            backgroundColor: getStatusColor(campaign.status),
                                            color: 'white'
                                        }}>
                                            {campaign.status || "DRAFT"}
                                        </span>
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        <span style={{ ...styles.badge, ...getApprovalBadge(campaign.approvalStatus || 'PENDING') }}>
                                            {campaign.approvalStatus || 'PENDING'}
                                        </span>
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        <span style={{
                                            ...styles.badge,
                                            backgroundColor: getPaymentStatusColor(campaign.paymentStatus || 'PENDING'),
                                            color: 'white'
                                        }}>
                                            {campaign.paymentStatus || 'PENDING'}
                                        </span>
                                    </td>
                                    <td style={styles.td}>{formatDate(campaign.startDate)}</td>
                                    <td style={styles.td}>{formatDate(campaign.endDate)}</td>
                                    <td style={styles.td}>{campaign.city || campaign.targeting?.city || "-"}</td>
                                    <td style={styles.td}>{campaign.radiusKm || campaign.targeting?.radiusKm ? `${campaign.radiusKm || campaign.targeting?.radiusKm} km` : "-"}</td>
                                    <td style={{ ...styles.td, fontSize: '11px' }}>{campaign.appType || "-"}</td>
                                    <td style={{ ...styles.td, fontSize: '11px' }}>
                                        <span style={{
                                            background: campaign.mediaType === 'VIDEO' ? '#fed7d7' : '#c6f6d5',
                                            padding: '2px 8px',
                                            borderRadius: '4px',
                                            fontSize: '10px',
                                            fontWeight: '600',
                                            color: campaign.mediaType === 'VIDEO' ? '#9b2c2c' : '#276749'
                                        }}>
                                            {campaign.mediaType || "-"}
                                        </span>
                                    </td>
                                    <td style={{ ...styles.td, fontSize: '11px' }}>
                                        {campaign.addDisplayPosition ? campaign.addDisplayPosition.replace(/_/g, ' ') : "-"}
                                    </td>
                                    <td style={styles.td}>
                                        {campaign.imageUrl ? (
                                            <button
                                                onClick={() => openMediaPreview(campaign.imageUrl)}
                                                style={{
                                                    ...styles.button,
                                                    ...styles.buttonInfo,
                                                    padding: '4px 10px',
                                                    height: '28px',
                                                    fontSize: '11px'
                                                }}
                                            >
                                                <Icons.Image /> View
                                            </button>
                                        ) : "-"}
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        <div style={styles.actionGroup}>
                                            <button
                                                onClick={() => handleViewCampaign(campaign)}
                                                style={{ ...styles.button, ...styles.buttonInfo }}
                                            >
                                                <Icons.View /> View
                                            </button>
                                            <button
                                                onClick={() => {
                                                    setSelectedCampaign(campaign);
                                                    setShowEditModal(true);
                                                }}
                                                style={{ ...styles.button, ...styles.buttonPrimary }}
                                            >
                                                <Icons.Edit /> Edit
                                            </button>
                                            <button
                                                onClick={() => handleDelete(campaign.id || campaign.campaignId)}
                                                style={{ ...styles.button, ...styles.buttonDanger }}
                                            >
                                                <Icons.Delete /> Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* View Modal */}
            {showViewModal && viewCampaign && (
                <div style={styles.modalOverlay} onClick={() => setShowViewModal(false)}>
                    <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <h3 style={styles.modalTitle}>
                                <Icons.View style={{ color: '#e66d33' }} /> Campaign Details
                            </h3>
                            <button style={styles.modalClose} onClick={() => setShowViewModal(false)}>
                                <Icons.Close />
                            </button>
                        </div>
                        <div style={styles.modalBody}>
                            {/* Basic Info */}
                            <div style={{ marginBottom: '16px' }}>
                                <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '10px', fontSize: '15px' }}>Basic Information</h4>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '8px', fontSize: '14px' }}>
                                    <strong>ID:</strong> <span>{viewCampaign.id || viewCampaign.campaignId}</span>
                                    <strong>Campaign Name:</strong> <span>{viewCampaign.campaignName}</span>
                                    <strong>Description:</strong> <span>{viewCampaign.description}</span>
                                    <strong>Goal:</strong> <span>{viewCampaign.goal}</span>
                                    <strong>Medium:</strong> <span>{viewCampaign.medium}</span>
                                    <strong>Status:</strong>
                                    <span style={{ ...styles.badge, backgroundColor: getStatusColor(viewCampaign.status), color: 'white' }}>
                                        {viewCampaign.status}
                                    </span>
                                    <strong>Approval Status:</strong>
                                    <span style={{ ...styles.badge, ...getApprovalBadge(viewCampaign.approvalStatus || 'PENDING') }}>
                                        {viewCampaign.approvalStatus || 'PENDING'}
                                    </span>
                                    <strong>Payment Status:</strong>
                                    <span style={{ ...styles.badge, backgroundColor: getPaymentStatusColor(viewCampaign.paymentStatus || 'PENDING'), color: 'white' }}>
                                        {viewCampaign.paymentStatus || 'PENDING'}
                                    </span>
                                </div>
                            </div>

                            {/* Dates */}
                            <div style={{ marginBottom: '16px' }}>
                                <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '10px', fontSize: '15px' }}>Dates</h4>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '8px', fontSize: '14px' }}>
                                    <strong>Start Date:</strong> <span>{formatDateTime(viewCampaign.startDate)}</span>
                                    <strong>End Date:</strong> <span>{formatDateTime(viewCampaign.endDate)}</span>
                                    <strong>Created At:</strong> <span>{formatDateTime(viewCampaign.createdAt)}</span>
                                </div>
                            </div>

                            {/* Targeting */}
                            <div style={{ marginBottom: '16px' }}>
                                <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '10px', fontSize: '15px' }}>Targeting</h4>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '8px', fontSize: '14px' }}>
                                    <strong>Interests:</strong>
                                    <span>
                                        {viewCampaign.targeting?.interests?.join(', ') ||
                                            viewCampaign.interests?.join(', ') || 'None'}
                                    </span>
                                    <strong>City:</strong> <span>{viewCampaign.city || viewCampaign.targeting?.city || 'Not specified'}</span>
                                    <strong>Radius:</strong> <span>{viewCampaign.radiusKm || viewCampaign.targeting?.radiusKm ? `${viewCampaign.radiusKm || viewCampaign.targeting?.radiusKm} km` : 'Not specified'}</span>
                                </div>
                            </div>

                            {/* Creative */}
                            {viewCampaign.imageUrl && (
                                <div style={{ marginBottom: '16px' }}>
                                    <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '10px', fontSize: '15px' }}>Creative</h4>
                                    <button
                                        onClick={() => openMediaPreview(viewCampaign.imageUrl)}
                                        style={{ ...styles.button, ...styles.buttonSuccess }}
                                    >
                                        <Icons.Image /> View Creative
                                    </button>
                                </div>
                            )}

                            {/* Approval Actions */}
                            <div style={{
                                padding: '16px',
                                background: '#f7fafc',
                                borderRadius: '8px',
                                border: '1px solid #edf2f7'
                            }}>
                                <h4 style={{ color: 'rgb(230 109 51)', marginBottom: '10px', fontSize: '14px' }}>Approval Actions</h4>
                                {showRejectionInput ? (
                                    <div>
                                        <label style={styles.label}>Rejection Reason *</label>
                                        <textarea
                                            placeholder="Please provide reason for rejection"
                                            value={rejectionReason}
                                            onChange={(e) => setRejectionReason(e.target.value)}
                                            rows="3"
                                            style={styles.textarea}
                                        />
                                        <div style={{ display: 'flex', gap: '8px', marginTop: '8px', justifyContent: 'flex-end' }}>
                                            <button
                                                onClick={() => {
                                                    setShowRejectionInput(false);
                                                    setRejectionReason('');
                                                }}
                                                style={{ ...styles.button, ...styles.buttonSecondary }}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                onClick={() => handleDirectReject(viewCampaign)}
                                                style={{ ...styles.button, ...styles.buttonDanger }}
                                            >
                                                Submit Rejection
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                        <button
                                            onClick={() => handleDirectApprove(viewCampaign)}
                                            disabled={viewCampaign.approvalStatus === 'APPROVED'}
                                            style={{
                                                ...styles.button,
                                                ...styles.buttonSuccess,
                                                opacity: viewCampaign.approvalStatus === 'APPROVED' ? 0.5 : 1,
                                                cursor: viewCampaign.approvalStatus === 'APPROVED' ? 'not-allowed' : 'pointer'
                                            }}
                                        >
                                            <Icons.Approve /> {viewCampaign.approvalStatus === 'APPROVED' ? 'Already Approved' : 'Approve'}
                                        </button>
                                        <button
                                            onClick={() => setShowRejectionInput(true)}
                                            disabled={viewCampaign.approvalStatus === 'REJECTED'}
                                            style={{
                                                ...styles.button,
                                                ...styles.buttonDanger,
                                                opacity: viewCampaign.approvalStatus === 'REJECTED' ? 0.5 : 1,
                                                cursor: viewCampaign.approvalStatus === 'REJECTED' ? 'not-allowed' : 'pointer'
                                            }}
                                        >
                                            <Icons.Reject /> {viewCampaign.approvalStatus === 'REJECTED' ? 'Already Rejected' : 'Reject'}
                                        </button>
                                    </div>
                                )}
                            </div>

                            <div style={styles.modalFooter}>
                                <button
                                    onClick={() => setShowViewModal(false)}
                                    style={{ ...styles.button, ...styles.buttonSecondary, flex: 1 }}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Add Modal - Simplified for brevity, same as original but with premium styling */}
            {showAddModal && (
                <div style={styles.modalOverlay} onClick={() => setShowAddModal(false)}>
                    <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <h3 style={styles.modalTitle}>
                                <Icons.Add style={{ color: '#e66d33' }} /> Create Campaign
                            </h3>
                            <button style={styles.modalClose} onClick={() => setShowAddModal(false)}>
                                <Icons.Close />
                            </button>
                        </div>
                        <div style={styles.modalBody}>
                            <form onSubmit={(e) => e.preventDefault()}>
                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Campaign Name *</label>
                                    <input
                                        type="text"
                                        name="campaignName"
                                        placeholder="Enter campaign name"
                                        value={formData.campaignName}
                                        onChange={(e) => setFormData({ ...formData, campaignName: e.target.value })}
                                        style={styles.input}
                                        required
                                    />
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Goal *</label>
                                    <select
                                        name="goal"
                                        value={formData.goal}
                                        onChange={(e) => setFormData({ ...formData, goal: e.target.value })}
                                        style={styles.select}
                                        required
                                    >
                                        {goalOptions.map((option) => (
                                            <option key={option} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Medium *</label>
                                    <select
                                        name="medium"
                                        value={formData.medium}
                                        onChange={(e) => setFormData({ ...formData, medium: e.target.value })}
                                        style={styles.select}
                                        required
                                    >
                                        {mediumOptions.map((option) => (
                                            <option key={option} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Start Date *</label>
                                    <input
                                        type="date"
                                        name="startDate"
                                        value={formData.startDate}
                                        onChange={(e) => setFormData({ ...formData, startDate: e.target.value })}
                                        style={styles.input}
                                        required
                                    />
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.label}>End Date *</label>
                                    <input
                                        type="date"
                                        name="endDate"
                                        value={formData.endDate}
                                        onChange={(e) => setFormData({ ...formData, endDate: e.target.value })}
                                        style={styles.input}
                                        required
                                    />
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Description</label>
                                    <textarea
                                        name="description"
                                        placeholder="Enter campaign description"
                                        value={formData.description}
                                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                        rows="3"
                                        style={styles.textarea}
                                    />
                                </div>

                                <div style={styles.modalFooter}>
                                    <button
                                        type="button"
                                        onClick={() => setShowAddModal(false)}
                                        style={{ ...styles.button, ...styles.buttonSecondary, flex: 1 }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        style={{ ...styles.button, ...styles.buttonPrimary, flex: 1 }}
                                    >
                                        Create Campaign
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Modal - Simplified for brevity */}
            {showEditModal && selectedCampaign && (
                <div style={styles.modalOverlay} onClick={() => setShowEditModal(false)}>
                    <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <h3 style={styles.modalTitle}>
                                <Icons.Edit style={{ color: '#e66d33' }} /> Edit Campaign
                            </h3>
                            <button style={styles.modalClose} onClick={() => setShowEditModal(false)}>
                                <Icons.Close />
                            </button>
                        </div>
                        <div style={styles.modalBody}>
                            <form onSubmit={(e) => e.preventDefault()}>
                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Campaign Name *</label>
                                    <input
                                        type="text"
                                        name="campaignName"
                                        placeholder="Enter campaign name"
                                        value={formData.campaignName}
                                        onChange={(e) => setFormData({ ...formData, campaignName: e.target.value })}
                                        style={styles.input}
                                        required
                                    />
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Goal *</label>
                                    <select
                                        name="goal"
                                        value={formData.goal}
                                        onChange={(e) => setFormData({ ...formData, goal: e.target.value })}
                                        style={styles.select}
                                        required
                                    >
                                        {goalOptions.map((option) => (
                                            <option key={option} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Medium *</label>
                                    <select
                                        name="medium"
                                        value={formData.medium}
                                        onChange={(e) => setFormData({ ...formData, medium: e.target.value })}
                                        style={styles.select}
                                        required
                                    >
                                        {mediumOptions.map((option) => (
                                            <option key={option} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </div>

                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Status *</label>
                                    <select
                                        name="status"
                                        value={formData.status}
                                        onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                                        style={styles.select}
                                        required
                                    >
                                        {statusOptions.map((option) => (
                                            <option key={option} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </div>

                                <div style={styles.modalFooter}>
                                    <button
                                        type="button"
                                        onClick={() => setShowEditModal(false)}
                                        style={{ ...styles.button, ...styles.buttonSecondary, flex: 1 }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        style={{ ...styles.button, ...styles.buttonPrimary, flex: 1 }}
                                    >
                                        Update Campaign
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                @keyframes slideUp {
                    from { opacity: 0; transform: translateY(30px) scale(0.95); }
                    to { opacity: 1; transform: translateY(0) scale(1); }
                }

                @media (max-width: 768px) {
                    .stats-container {
                        grid-template-columns: 1fr 1fr !important;
                    }
                    .table-container table {
                        font-size: 12px !important;
                    }
                    .table-container table th,
                    .table-container table td {
                        padding: 6px 8px !important;
                        font-size: 10px !important;
                    }
                    .modal {
                        padding: 16px !important;
                        width: 98% !important;
                    }
                }

                @media (max-width: 480px) {
                    .stats-container {
                        grid-template-columns: 1fr !important;
                    }
                    .stat-value {
                        font-size: 18px !important;
                    }
                    .table-container table {
                        font-size: 10px !important;
                        min-width: 1200px !important;
                    }
                    .table-container table th,
                    .table-container table td {
                        padding: 4px 6px !important;
                        font-size: 9px !important;
                    }
                    .badge {
                        font-size: 8px !important;
                        padding: 2px 6px !important;
                    }
                    .button {
                        font-size: 10px !important;
                        padding: 4px 8px !important;
                        height: 26px !important;
                    }
                }

                ::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                }
                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb {
                    background: linear-gradient(135deg, #e66d33 0%, #d45a2a 100%);
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(135deg, #d45a2a 0%, #b84a1a 100%);
                }

                .spinner-border {
                    display: inline-block;
                    width: 2rem;
                    height: 2rem;
                    border: 0.25em solid currentColor;
                    border-right-color: transparent;
                    border-radius: 50%;
                    animation: spinner-border 0.75s linear infinite;
                }
                @keyframes spinner-border {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default FoodSuperadminCampaign;